<template>


<div class="headerslider bannerImage slmm-mobile-hide">
   <!-- START Slider Home2 940px REVOLUTION SLIDER 6.1.3 -->
   <div class="rs-fullwidth-wrap" id="rev_slider_33_1_forcefullwidth" style="margin-top:0px;margin-bottom:0px;">
      <div class="rs-module-wrap" id="rev_slider_33_1_wrapper" data-source="gallery" style="background: rgb(21, 24, 35); padding: 0px; margin: 0px auto; position: absolute; overflow: visible; width: 1905px; left: 0px; height: 800px;">
         <div id="rev_slider_33_1" style="height: 800px; max-height: 800px; margin-top: 0px; margin-bottom: 0px;" data-version="6.1.3" class="rs-module revslider-initialised rev_redraw_on_blurfocus" data-idcheck="true" data-slideactive="rs-61">
            <div class="rs-slides" style="visibility: visible; display: block; max-height: none; height: 100%; width: 100%; overflow: hidden;">
               <div data-key="rs-61" data-title="New Slide 3" data-anim="ei:d;eo:d;s:d;r:0;t:fade;sl:d;" data-originalindex="1" data-origindex="0" data-description="" data-sba="" data-scroll-based="false" style="overflow: hidden; height: 100%; width: 100%; z-index: 20; visibility: inherit; opacity: 1;" data-owidth="1920" data-oheight="940" data-ntrid="0" class="rs-slide active-rs-slide">
                  <div class="rs-layer-wrap rs-parallax-wrap" style="position: absolute; display: block; pointer-events: auto; left: 378px; top: 295px; z-index: 14; visibility: visible;">
                     <div style="position:absolute;display:block;">
                        <div class="rs-mask-wrap" style="position: absolute; display: block; visibility: visible; overflow: visible;">
                           <div class="rs-layer wow animated bounceInDown" data-wow-duration="1s" data-wow-delay="0s" id="slider-33-slide-61-layer-24" data-type="text" data-xy="xo:10px;yo:295px,295px,220px,140px;" data-text="w:normal;s:80,72,50,40;l:88,76,70,50;fw:700;" data-dim="w:auto,90%,90%,90%;" data-rsp_o="off" data-rsp_bd="off" data-frame_0="sX:0.9;sY:0.9;" data-frame_1="st:770;sp:1000;sR:770;" data-frame_999="o:0;st:w;sR:7230;" style="z-index: 14; font-family: Montserrat; visibility: visible; text-align: left; line-height: 88px; letter-spacing: 0px; font-weight: 700; font-size: 80px; border-color: rgb(102, 102, 102); border-style: none; margin: 0px; border-radius: 0px; padding: 0px; color: rgb(255, 255, 255); text-decoration: none; white-space: nowrap; width: auto; height: auto; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;"  data-idcheck="true" data-stylerecorder="true" data-initialised="true">
                              <slot name="title">Next Generation</slot><br>
                              <slot name="subtitle"/>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div class="rs-fw-forcer" style="height:800px"></div>
   </div>
   <!-- END REVOLUTION SLIDER -->
</div>


</template>

<script>
export default {
  name: "HomeBanner",
  props: ["title", "subtitle", "header"],
  data() {
    return {
      msg: "HomeBanner",
      image: "../../assets/images/For-BG-02-1.jpg"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bannerImage{
   background-color: transparent;
   background-repeat: no-repeat;
   background-image: url(../../assets/images/First_screen_image_Main_02-03.jpg) !important;
   background-size: cover;
   background-position: 50% 50%;
   width: 100%;
   height: 100%;
   opacity: 1;
   top: 0px;
   left: 0px;
   visibility: inherit;
   z-index: 20;
}

@media screen and (max-width: 999px) {
    .slmm-mobile-hide {
        display: none !important;
    }
}
@media all{
.rs-sbg-px{pointer-events:none;}
.rs-module-wrap,.rs-module-wrap *{box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0);}
.rs-module-wrap{position:relative;z-index:1;width:100%;display:block;}
.rs-fw-forcer{display:block;width:100%;pointer-events:none;}
.rs-module{position:relative;overflow:hidden;display:block;}
.rs-sbg{display:block;pointer-events:none;}
.rs-sbg-px,.rs-sbg-wrap{position:absolute;top:0;left:0;z-index:0;width:100%;height:100%;display:block;}
a.rs-layer,a.rs-layer:-webkit-any-link{text-decoration:none;}
.rs-module a{box-shadow:none;}
.rs-module img{max-width:none!important;transition:none;margin:0;padding:0;border:none;}
.rs-slides,.rs-slide,.rs-slide:before{position:absolute;text-indent:0em;top:0;left:0;}
.rs-slide,.rs-slide:before{display:block;visibility:hidden;}
.rs-module .rs-layer,.rs-module .rs-layer{opacity:0;position:relative;visibility:hidden;white-space:nowrap;display:block;-webkit-font-smoothing:antialiased!important;-webkit-tap-highlight-color:rgba(0,0,0,0);-moz-osx-font-smoothing:grayscale;z-index:1;}
.rs-layer-wrap,.rs-module-wrap,.rs-module .rs-layer,.rs-module img{-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none;}
.rs-module .rs-mask-wrap .rs-layer,.rs-module .rs-mask-wrap *:last-child{margin-bottom:0;}
.rs-layer,.rs-layer,.rs-layer *{outline:none!important;}
.rs-layer-wrap,.rs-mask-wrap,div{display:block;visibility:hidden;}
.rs-layer-wrap,.rs-mask-wrap{transform-style:flat;perspective:10000px;}
.rs-mask-wrap{overflow:hidden;}
.rs-fullwidth-wrap{position:relative;width:100%;height:auto;display:block;}
.rs-layer img,.rs-layer img{vertical-align:top;}
.rs-static-layers{position:absolute;z-index:101;top:0;left:0;display:block;width:100%;height:100%;pointer-events:none;}
.rev-btn,.rev-btn:visited{outline:none!important;box-shadow:none;text-decoration:none!important;box-sizing:border-box;cursor:pointer;}
.rs-progress{visibility:hidden;width:100%;height:5px;background:#000;background:rgba(0,0,0,.15);position:absolute;z-index:200;top:0;}
.rs-progress.rs-bottom{top:auto;bottom:0px!important;height:5px;}
.rs-layer img{background:transparent;-ms-filter:"progid:DXImageTransform.Microsoft.gradient(startColorstr=#00FFFFFF,endColorstr=#00FFFFFF)";filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#00FFFFFF,endColorstr=#00FFFFFF);zoom:1;}
.rs-loader{top:50%;left:50%;z-index:10000;position:absolute;}
.rs-loader.spinner3{margin:-9px 0 0 -35px;width:70px;text-align:center;}
.rs-loader.spinner3 .bounce1,rs-loader.spinner3 .bounce2,rs-loader.spinner3 .bounce3{width:18px;height:18px;background-color:#fff;box-shadow:0 0 20px 0 rgba(0,0,0,.15);border-radius:100%;display:inline-block;animation:tp-bouncedelay 1.4s infinite ease-in-out;animation-fill-mode:both;}
.rs-loader.spinner3 .bounce1{animation-delay:-0.32s;}
.rs-loader.spinner3 .bounce2{animation-delay:-0.16s;}
.bgcanvas{display:none;position:absolute;oveflow:hidden;}
.screen-reader-text{clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;position:absolute!important;width:1px;word-wrap:normal!important;}
.clear{clear:both;}
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
div.kc_col-of-5{width:20%;float:left;}
.kc_col-sm-3{width:25%;}
.kc_col-sm-4{width:33.3333%;}
.kc_col-sm-6{width:50%;}
.kc_col-sm-8{width:66.6667%;}
.kc_col-sm-12{width:100%;}
.kc-container{width:100%;max-width:1170px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc-row-container:not(.kc-container){padding-left:0;padding-right:0;width:100%;max-width:100%;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_row.kc_row_inner{width:calc(100% + 30px);}
.kc_column,.kc_column_inner{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container,.kc_column_inner>.kc-col-inner-container{height:100%;}
.kingcomposer div.kc_column,.kingcomposer div.kc_column_inner{clear:none;}
.kc_row_inner>div.kc_column_inner:only-child{width:100%;}
.kc_clfw{width:100%!important;clear:both!important;display:block!important;height:0!important;padding:0!important;margin:0!important;}
.kc-col-container{clear:both;display:block;width:100%;}
.kc_text_block{display:inline-block;clear:both;width:100%;}
body section[data-kc-equalheight=true],body section[data-kc-equalheight=true]>.kc-container,body section[data-kc-equalheight=true]>.kc-container .kc-wrap-columns{display:-webkit-flex!important;display:-ms-flexbox!important;display:flex!important;width:100%;}
body section[data-kc-equalheight-align=middle]>.kc-container>.kc-wrap-columns>.kc_column>.kc-col-container,body section[data-kc-equalheight-align=middle]>.kc-row-container>.kc-wrap-columns>.kc_column>.kc-col-container{display:-webkit-flex!important;display:-ms-flexbox!important;display:flex!important;flex-wrap:wrap;height:100%;width:100%;}
body section[data-kc-equalheight-align=middle]>.kc-container>.kc-wrap-columns>.kc_column>.kc-col-container,body section[data-kc-equalheight-align=middle]>.kc-row-container>.kc-wrap-columns>.kc_column>.kc-col-container{align-content:center;justify-content:center;align-items:center;}
body section[data-kc-equalheight=true]>.kc-container .kc-wrap-columns{flex-wrap:wrap;margin-left:initial;margin-right:initial;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns,.kc_row_inner{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column,body.kc-css-system .kc_column_inner{width:100%;}
div.kc_row{display:block;}
}
.kc_tabs{margin-bottom:24px;}
.kc_tabs{display:inline-block;width:100%;}
.kc-pricing-layout-1{box-shadow:0 1px 21px rgba(0,0,0,.21);}
.kc-pricing-tables{transition:all .3s ease 0s;}
.content-title{margin:25px 0 20px;font-size:20px;text-transform:uppercase;font-weight:700;color:#444;}
.content-desc{font-weight:400;margin-bottom:25px;color:rgba(86,86,86,.8);padding:0;}
.content-button a{display:inline-block;padding:7px 20px;text-transform:uppercase;background:#eee;color:#666;font-size:12px;}
.kc-pricing-tables{float:left;width:100%;overflow:hidden;}
.kc-pricing-layout-1{border-radius:10px;overflow:hidden;background:#42BCE2;}
.kc-pricing-layout-1 .header-pricing{float:left;width:100%;line-height:1.4;}
.kc-pricing-layout-1 .header-pricing .kc-pricing-price{float:left;width:100%;text-align:center;}
.kc-pricing-layout-1 .kc-pricing-price .content-price{padding-bottom:30px;}
.kc-pricing-layout-1 .header-pricing .kc-pricing-price span{font-weight:400;color:#fff;font-size:28px;}
.kc-pricing-layout-1 .header-pricing .kc-pricing-price span.content-duration{font-size:16px;color:#fff;}
.kc-pricing-layout-1 .header-pricing .content-title{float:left;width:100%;text-align:center;font-size:20px;margin:0;font-weight:700;text-transform:uppercase;color:#fff;background:rgba(0,0,0,.1);padding:15px 0;}
.kc-pricing-layout-1 .content-desc{float:left;width:100%;list-style:none;margin:0;text-align:center;padding:0;}
.kc-pricing-tables .content-desc li:last-child{margin-left:0!important;margin-top:0!important;margin-right:0!important;}
.kc-pricing-tables .content-desc li:first-child{margin-left:0!important;margin-bottom:0!important;margin-right:0!important;}
.kc-pricing-layout-1 .content-desc li{float:left;width:100%;padding:8px 0;font-size:14px;color:#173d50;}
.kc-pricing-tables .content-desc li{border-left:0!important;border-right:0!important;list-style:none;}
.kc-pricing-tables .content-desc li:not(:last-child){border-bottom:0!important;}
.kc-pricing-layout-1 .content-desc li:nth-of-type(2n+1){background:#F1F3F5;}
.kc-pricing-layout-1 .content-button{float:left;width:100%;text-align:center;background:#42BCE2;}
.kc-pricing-layout-1 .content-button a{display:inline-block;margin-top:25px;margin-bottom:25px;background:rgba(0,0,0,.1);color:#fff;}
.kc-pricing-layout-1 .content-button a:hover{background:#fff;color:#42BCE2;}
.kc-pricing-price span{display:inline-block;}
.entry-content a{box-shadow:none;}
.kc-multi-icons-wrapper i{width:1em;height:1em;text-align:center;color:#fff;font-size:20px;}
.kc-multi-icons-wrapper a{padding:10px;margin:3px;background:#1E73BE;line-height:1;display:inline-block;border-radius:3px;}
.kc-multi-icons-wrapper a:last-child{margin-right:0!important;}
.divider_line{float:left;width:100%;margin-top:30px;margin-bottom:30px;}
.divider_line .divider_inner{display:inline-block;width:100%;border-bottom:1px solid #ccc;border-top:0!important;border-left:0!important;border-right:0!important;}
.content-button a{transition:all .3s ease 0s;}
.content-subtitle{float:left;width:100%;}
[class^="nat-"],[class*=" nat-"]{font-family:'native'!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.nat-running:before{content:"\e90f";}
.nat-tag-label--branding-3:before{content:"\ebe4";}
.nat-coins-growth-money:before{content:"\ebea";}
.nat-computer-design-2:before{content:"\ebeb";}
.nat-graphic-design:before{content:"\ebfd";}
.nat-lamp-idea-9:before{content:"\ec0b";}
.nat-light-bulb2:before{content:"\ec0e";}
.nat-cirleborder:before{content:"\ebd0";}
.nat-bse-chronometer:before{content:"\e9c5";}
.nat-bse-phone-call:before{content:"\e9f0";}
.nat-stats-1:before{content:"\eb3f";}
.nat-rocket2:before{content:"\ec25";}
.nat-620:before{content:"\e26c";}
.nat-images3:before{content:"\e940";}
.nat-envelop4:before{content:"\ec3b";}
.nat-search3:before{content:"\ec55";}
.nat-magic-wand2:before{content:"\eb6e";}
.nat-grid4:before{content:"\ec66";}
.nat-grid6:before{content:"\ec69";}
[class*=" sl-"],[class*=" sl-"]:before{font-family:'simple-line-icons';font-style:inherit;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:auto;speak:none;font-weight:400;}
.sl-picture:before{content:"\e032";}
[class^="fa-"],[class*=" fa-"],[class^="fa-"]:before,[class*=" fa-"]:before,[class^="fab-"],[class^="fab-"]:before{font-family:'FontAwesome';font-style:inherit;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;text-rendering:auto;speak:none;font-weight:400;}
[class^="fab-"],[class^="fab-"]:before{font-family:'FontAwesomeBrands';}
.fa-arrow-up:before{content:"\f062";}
.fa-bars:before{content:"\f0c9";}
.fab-behance:before{content:"\f1b4";}
.fa-chevron-down:before{content:"\f078";}
.fa-clock:before{content:"\f017";}
.fa-exclamation:before{content:"\f12a";}
.fab-facebook-f:before{content:"\f39e";}
.fa-folder:before{content:"\f07b";}
.fa-font:before{content:"\f031";}
.fab-instagram:before{content:"\f16d";}
.fa-leaf:before{content:"\f06c";}
.fab-linkedin-in:before{content:"\f0e1";}
.fa-list:before{content:"\f03a";}
.fab-twitter:before{content:"\f099";}
.fa-user:before{content:"\f007";}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus,i:focus{outline:none;}
body{line-height:1.7;font-family:"Catamaran";font-size:17px;color:#666;font-weight:400;background-color:rgba(255,255,255,1);-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;margin:0;-ms-word-wrap:break-word;word-break:break-word;}
article,figure,main,section{display:block;}
canvas{display:inline-block;vertical-align:baseline;}
img{border:0;max-width:100%;}
img.wp-post-image{height:auto;max-width:100%;display:flex;margin:0 auto;}
svg:not(:root){overflow:hidden;}
figure{margin:0 auto;}
button,input,textarea{margin:0;}
button{overflow:visible;}
button{text-transform:none;}
button,input[type="submit"]{-webkit-appearance:button;cursor:pointer;}
button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0;}
input{line-height:normal;}
input[type="search"]{-webkit-appearance:textfield;box-sizing:content-box;}
textarea{overflow:auto;}
.screen-reader-text{clip:rect(1px,1px,1px,1px);position:absolute!important;height:1px;width:1px;overflow:hidden;}
.screen-reader-text:focus{background-color:#f1f1f1;border-radius:3px;box-shadow:0 0 2px 2px rgba(0,0,0,.6);clip:auto!important;color:#21759b;display:block;font-size:14px;font-size:.875rem;font-weight:700;height:auto;left:5px;line-height:normal;padding:15px 23px 14px;text-decoration:none;top:5px;width:auto;z-index:100000;}
.clear:before,.clear:after,.entry-content:before,.entry-content:after{content:"";display:table;table-layout:fixed;}
.clear:after,.entry-content:after{clear:both;}
button,input,textarea{font-family:"Catamaran";font-size:16px;line-height:1.5;border:0;outline:none;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:full-size-kana;text-align:left;margin:20px 0 15px 0;}
h3{font-family:"Catamaran";color:#222;font-weight:500;font-size:25px;line-height:32px;text-align:left;margin:20px 0;}
p{margin:10px 0 25px 0;}
.page p{line-height:29px;}
p a{outline:0;color:#ED7D31;}
i{font-style:italic;}
input[type="text"],input[type="submit"],input[type="email"],input[type="search"],input[type="tel"],html body textarea{background-color:rgba(116,131,190,.2);color:rgba(126,131,153,1);border-radius:50px;border-width:1px 1px 1px 1px;border-style:solid;border-color:#e5e6eb;height:50px;line-height:50px;box-sizing:border-box;outline:none;max-width:100%;}
html body textarea{line-height:26px;}
input[type="text"]:focus,input[type="email"]:focus,input[type="search"]:focus,input[type="tel"]:focus,html body textarea:focus{color:#333;border-color:rgba(243,84,68,1);}
input[type="text"],input[type="submit"],input[type="email"],input[type="search"],input[type="tel"]{padding:0 18px;}
html body textarea{padding:11px 15px;height:100px;width:100%;}
input[type="text"]::-webkit-input-placeholder,input[type="email"]::-webkit-input-placeholder,input[type="tel"]::-webkit-input-placeholder,html body textarea::-webkit-input-placeholder,input[type="text"]::-moz-placeholder,input[type="email"]::-moz-placeholder,input[type="tel"]::-moz-placeholder,html body textarea::-moz-placeholder,input[type="text"]:-moz-placeholder,input[type="email"]:-moz-placeholder,input[type="tel"]:-moz-placeholder,html body textarea:-moz-placeholder,input[type="text"]:-ms-input-placeholder,input[type="email"]:-ms-input-placeholder,input[type="tel"]:-ms-input-placeholder,html body textarea:-ms-input-placeholder{color:#b2b9be;}
.footer-widget button,main input[type="submit"],.headline input[type="submit"]{display:block;border-radius:50px;border-width:2px 2px 2px 2px;border-style:solid;border-color:#ED7D31;background-color:rgba(245,94,102,0);box-shadow:none;color:rgba(34,34,34,1);font-size:14px;text-transform:uppercase;padding:0 40px;text-shadow:none;line-height:44px;outline:none;font-weight:700;outline:0;margin:0 auto;}
.footer-widget button:hover,main input[type="submit"]:hover,.headline input[type="submit"]:hover{color:rgba(255,255,255,1);box-shadow:none;background-color:rgba(243,84,68,1);border-width:2px 2px 2px 2px;border-style:solid;border-color:#ED7D31;}
ul{margin:0 0 1.5em 1em;}
ul{list-style:disc;}
ul li ul{list-style-type:circle;}
ul li ul li ul{list-style-type:square;}
li>ul{margin-bottom:0;margin-left:0;}
*,*:before,*:after{box-sizing:inherit;}
body{background:#fff;overflow:hidden;}
main:after{content:"";display:block;clear:both;}
.headline:after{content:"";clear:both;display:block;}
.footer-widget{z-index:2;position:relative;}
button::-moz-focus-inner{padding:0;border:0;}
.hentry{margin:0 0 0 0;}
.updated:not(.published){display:none;}
body [class*="layout5"] .thumb img{transition:all 0.3s ease,transform 0.3s ease-out;}
body [class*="layout5"] .thumb:hover img{transform:scale(1.1);}
.page.kingcomposer main{padding:0;max-width:100%;}
.entry-meta{color:rgba(102,102,102,1);margin:0 0 0 0;-webkit-transition:all 200ms;transition:all 200ms;padding:0 0 0 0;line-height:1.4em;font-size:14px;}
.entry-meta .updated{display:none;}
.entry-meta>span,.entry-meta>div{margin:0 16px 10px 0;display:inline-block;border-right:1px solid #ddd;padding-right:15px;line-height:17px;overflow:hidden;}
.entry-meta>span:last-child{border-right:0;margin-right:0;padding-right:5px;}
.entry-meta:after{content:" ";display:block;clear:both;}
article:after{content:"";display:block;clear:both;width:100%;}
article .thumb img{display:flex;}
.kc_row.kc_row_inner:focus{outline:none;}
.widget_custom_post_widget:after{content:"";display:block;clear:both;}
.search-form,.search-form label,.search-form input{width:100%;position:relative;}
.search-field{margin-bottom:20px;}
.search-form input{width:100%;}
#scroller{position:fixed;bottom:50px;right:10%;background-color:rgba(0,0,0,.5);filter:alpha(opacity=50);color:#FFF;transition:all 500ms;width:60px;height:60px;border-radius:80px;text-align:center;padding-top:18px;text-decoration:none;z-index:1050;transform:scale(1);opacity:.5;display:none;font-size:0;}
#scroller svg{width:20px;}
#scroller span{display:none;}
#scroller:hover{opacity:1;filter:alpha(opacity=100);text-decoration:none;}
#scroller:hover:active,#scroller:active,#scroller:focus,#scroller:hover:focus{outline:none;text-decoration:none;}
img{height:auto;max-width:100%;}
.row:before,.row:after{content:" ";display:table;}
.row:after{clear:both;}
.row{margin-left:-15px;margin-right:-15px;}
.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px;}
@media (min-width:768px){
.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-12{float:left;}
.col-sm-12{width:100%;}
.col-sm-7{width:58.33333333%;}
.col-sm-6{width:50%;}
.col-sm-5{width:41.66666667%;}
}
.hidden{display:none!important;}
html body section[data-kc-equalheight="true"]>.kc-container .kc-wrap-columns{margin-left:-15px;margin-right:-15px;width:calc(100% + 30px);}
.kc-row-container:after{content:"";display:block;clear:both;}
body .divider_line{margin-top:0;margin-bottom:0;line-height:1;}
body .kc_tab_content:after{content:"";display:block;clear:both;}
.owl-theme .owl-controls{margin-top:20px;text-align:center;}
.owl-theme .owl-controls .owl-buttons>div{color:#FFF;display:inline-block;zoom:1;*display:inline;margin:5px;padding:3px 10px;font-size:8px;-webkit-border-radius:30px;-moz-border-radius:30px;border-radius:50px;background:#272727;filter:Alpha(Opacity=50);opacity:.5;}
.owl-theme .owl-controls.clickable .owl-buttons div:hover{filter:Alpha(Opacity=100);opacity:1;text-decoration:none;}
.owl-theme .owl-controls .owl-page{display:inline-block;zoom:1;*display:inline;}
.owl-theme .owl-controls .owl-page span{display:block;width:8px;height:8px;margin:5px 3px;filter:Alpha(Opacity=30);opacity:.3;-webkit-border-radius:20px;-moz-border-radius:20px;border-radius:20px;background:#272727;}
.owl-theme .owl-controls .owl-page.active span,.owl-theme .owl-controls.clickable .owl-page:hover span{filter:Alpha(Opacity=100);opacity:1;}
.owl-carousel .owl-wrapper:after{content:".";display:block;clear:both;visibility:hidden;line-height:0;height:0;}
.owl-carousel{display:none;position:relative;width:100%;-ms-touch-action:pan-y;}
.owl-carousel .owl-wrapper{display:none;position:relative;-webkit-transform:translate3d(0,0,0);}
.owl-carousel .owl-wrapper-outer{overflow:hidden;position:relative;width:100%;}
.owl-carousel .owl-item{float:left;}
.owl-controls .owl-page,.owl-controls .owl-buttons div{cursor:pointer;}
.owl-controls{-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);}
.owl-carousel .owl-wrapper,.owl-carousel .owl-item{-webkit-backface-visibility:hidden;-moz-backface-visibility:hidden;-ms-backface-visibility:hidden;-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);}
body .owl-theme .owl-controls .owl-page.active span,.owl-theme .owl-controls.clickable .owl-page:hover span{transform:scale(1.3);}
body .owl-theme .owl-controls .owl-buttons>div{opacity:.8;background-color:#474747;font-weight:700;padding:5px 20px;font-size:14px;text-align:center;}
body .owl-theme .owl-controls .owl-buttons>div:hover{opacity:1;}
.content-button a{text-decoration:none;}
.owl-theme .owl-controls .owl-page span{transition:all 0.3s;}
.kc-col-container>div{position:relative;}
.kc-col-container>div.bgrlabel{z-index:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}
@media screen and (max-width:768px){
ul{margin:0 0 1.5em 1em;}
.entry-meta>span,.entry-meta>div{float:none;}
input[type="text"],input[type="email"],input[type="search"],input[type="tel"],textarea{width:100%;}
.footer-widget button,main input[type="submit"]{max-width:100%;white-space:normal;}
.entry-meta{line-height:1.8em;}
.entry-meta>span,.entry-meta>div{display:inline-block;}
}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
body{font-family:"Catamaran";font-size:16px;color:#666;font-weight:400;}
p{margin:10px 0 25px 0;line-height:26px;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
@media screen and (max-width:540px){
ul{margin:0 0 1.5em 0;}
.entry-meta .author{display:none;}
}
.caldera-grid *,.caldera-grid :after,.caldera-grid :before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;}
.caldera-grid input,.caldera-grid textarea{font-family:inherit;font-size:inherit;line-height:inherit;}
.caldera-grid .sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;}
.caldera-grid .row{margin-left:-7.5px;margin-right:-7.5px;max-width:100%;}
.caldera-grid .col-sm-12,.caldera-grid .col-sm-5,.caldera-grid .col-sm-6,.caldera-grid .col-sm-7{position:relative;padding-left:7.5px;padding-right:7.5px;}
@media (min-width:768px){
.caldera-grid .col-sm-12,.caldera-grid .col-sm-5,.caldera-grid .col-sm-6,.caldera-grid .col-sm-7{float:left;}
.caldera-grid .col-sm-12{width:100%;}
.caldera-grid .col-sm-7{width:58.33333333%;}
.caldera-grid .col-sm-6{width:50%;}
.caldera-grid .col-sm-5{width:41.66666667%;}
}
.caldera-grid .row:after,.caldera-grid .row:before{content:" ";display:table;}
.caldera-grid .row:after{clear:both;}
.caldera-grid .hide{display:none!important;}
.caldera-grid textarea{overflow:auto;}
.caldera-grid input,.caldera-grid textarea{font:inherit;margin:0;}
.caldera-grid input[type=submit]{-webkit-appearance:button;cursor:pointer;}
.caldera-grid input::-moz-focus-inner{border:0;padding:0;}
.caldera-grid input{line-height:normal;}
@media print{
.caldera-grid *,.caldera-grid :after,.caldera-grid :before{background:0 0!important;color:#000!important;box-shadow:none!important;text-shadow:none!important;}
}
.caldera-grid .btn,.caldera-grid .btn-default:active,.caldera-grid .btn:active,.caldera-grid .form-control{background-image:none;}
.caldera-grid label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700;}
.caldera-grid .form-group{margin-bottom:15px;}
.caldera-grid .form-control{font-size:14px;line-height:1.42857143;color:#555;display:block;}
.caldera-grid .form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;border:1px solid #ccc;border-radius:2px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;}
.caldera-grid .form-control:focus{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);}
.caldera-grid .form-control::-moz-placeholder{color:#999;opacity:1;}
.caldera-grid .form-control:-ms-input-placeholder{color:#999;}
.caldera-grid .form-control::-webkit-input-placeholder{color:#999;}
.caldera-grid .btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857143;border-radius:2px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}
.caldera-grid .btn:active:focus,.caldera-grid .btn:focus{outline:dotted thin;outline:-webkit-focus-ring-color auto 5px;outline-offset:-2px;}
.caldera-grid .btn:focus,.caldera-grid .btn:hover{color:#333;text-decoration:none;}
.caldera-grid .btn:active{outline:0;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125);}
.caldera-grid .btn-default{color:#333;background-color:#fff;border-color:#ccc;}
.caldera-grid .btn-default:active,.caldera-grid .btn-default:focus,.caldera-grid .btn-default:hover{color:#333;background-color:#e6e6e6;border-color:#adadad;}
.caldera-grid textarea.form-control{padding-right:4px;height:auto;}
.caldera-grid .screen-reader-text{clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;position:absolute!important;width:1px;word-wrap:normal!important;}
.kc_text_block a{transition:all 0.4s;}
.kc-multi-icons-wrapper a{text-decoration:none;}
body .bgrlabel{float:none;position:absolute;display:inline-block;width:auto;}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.befbgr img{max-width:100%;height:auto;}
.intl-tel-input{width:100%;}
.caldera-grid{width:100%;}
body .intl-tel-input.allow-dropdown .flag-container:hover .selected-flag{background-color:rgba(0,0,0,0);}
body .caldera-grid .form-group{margin-bottom:0;width:100%;}
.ssc_caldf{clear:both;}
body.kc-css-system .caldera-grid input[type="submit"]{width:auto;transition:all 300ms;}
body.kc-css-system .caldera-grid textarea{overflow:hidden;resize:none;}
body .caldera-grid .form-control{-webkit-box-shadow:none;box-shadow:none;}
body .intl-tel-input.allow-dropdown .selected-flag{width:52px;}
.intl-tel-input.allow-dropdown .flag-container:hover .selected-flag{background-color:transparent;}
body .intl-tel-input .selected-flag{padding:0 0 0 14px;}
a.ssc_button{position:relative;display:inline-block;transition:all 300ms ease-in;overflow:hidden;}
a.ssc_button span{position:relative;z-index:5;display:inline-block;}
.ssc_searchf.kc-elm{width:auto;}
.ssc_searchf:after,.ssc_btn:after{content:"";display:block;clear:both;}
.c_svg{display:table;z-index:2;position:relative;}
.c_svg div{display:table-cell;width:100%;vertical-align:middle;}
.c_svg svg{max-width:100%;max-height:100%;}
.ssc_icon_box.kc-elm{margin-bottom:10px;width:auto;}
.ssc_icon_box:after{content:"";display:block;clear:both;}
.ssc_icon_box a,.ssc_icon_box i{transition:all 300ms ease-in;}
body .ssc_icon_box .title a{background-image:none!important;}
.ssc_icon_box,.ssc_icon_box .bgr_icon,.ssc_icon_box .bgr_icon i,.ssc_icon_box .bgr_no,.ssc_icon_box .c_img,.ssc_icon_box .c_img img,.ssc_icon_box .c_text,.ssc_icon_box .icon_box,.ssc_icon_box .cont_box,.ssc_icon_box .title,.ssc_icon_box .cont_box .description,.ssc_icon_box .c_svg{transition:all 350ms ease-in;}
.ssc_icon_box.template1{display:table;}
.ssc_icon_box.template1>div{display:table-cell;}
.ssc_icon_box.template1 .cont_box{padding-left:30px;}
.ssc_icon_box.template3{text-align:center;}
.ssc_icon_box.template3 .title{margin-top:20px;}
.ssc_icon_box.template3 .bgr_icon i{margin:0 auto;}
.ssc_icon_box.template3 .c_svg{margin-left:auto;margin-right:auto;}
.ssc_icon_box.template3 .icon_box{width:100%;}
.ssc_icon_box .bgr_icon{position:relative;z-index:1;}
.ssc_icon_box .bgr_icon i{display:block;}
.ssc_icon_box .bgr_no{position:relative;z-index:1;display:block;}
.ssc_icon_box .bgr_no div{display:block;}
.ssc_icon_box .c_img{position:relative;z-index:9;text-align:center;margin-left:auto;margin-right:auto;}
.ssc_icon_box .c_img img{margin-top:calc((90px - 40px)/2);}
.ssc_icon_box .c_text{color:#ef5229;position:relative;z-index:9;text-align:center;font-size:30px;font-weight:700;}
.ssc_icon_box .icon_box{width:10px;}
.ssc_icon_box .cont_box{vertical-align:top;}
.ssc_icon_box .title{margin-bottom:2px;font-size:20px;font-weight:700;}
.ssc_icon_box .cont_box .description{line-height:1.4em;}
.ssc_icon_box .cont_box .description p:first-child{margin-top:0;}
.ssc_icon_box .cont_box .description p:last-child{margin-bottom:0;}
.ssc_icon_box.template18{text-align:center;}
.ssc_icon_box.template18 .title{margin-top:20px;}
.ssc_icon_box.template18 .bgr_icon i{margin:0 auto;}
.ssc_icon_box.template18 .c_text{position:absolute;left:0;top:0;}
.ssc_icon_box.template18 .icon_box{width:100%;position:relative;}
.ssc_post_grid .thumb span{width:100%;}
.ssc_post_grid .date{-webkit-filter:grayscale(0)!important;filter:none!important;}
.ssc_post_grid:after{content:"";display:block;clear:both;width:100%;}
.ssc_post_grid .title a{text-decoration:none;}
.ssc_post_grid.col1 .grid-item{width:100%;}
.ssc_post_grid.col2 .grid-item{width:50%;}
.grid-item:focus{outline:none;}
.ssc_post_grid .grid-item .thumb{display:flex;margin:0 auto;position:relative;overflow:hidden;width:100%;}
.ssc_post_grid .grid-item .thumb img{width:100%;height:100%;margin:0 auto -8px auto;}
.ssc_post_grid .grid-item{float:left;}
.ssc_post_grid .grid-item .title a{text-decoration:none;font-weight:700;margin-bottom:15px;display:block;outline:none;}
.ssc_post_grid .grid-item .meta{color:inherit;margin-bottom:15px;}
.ssc_post_grid .grid-item .meta i{margin-right:5px;}
.ssc_post_grid .grid-item .meta>span{margin-right:15px;}
.ssc_post_grid .grid-item p{margin-bottom:15px;}
.ssc_post_grid .grid-item a.rm{display:inline-block;transition:all 300ms ease-in;}
.ssc_post_grid .grid-item .pbody:after{content:"";display:block;clear:both;}
.ssc_post_grid .grid-item .pbody{transition:all 300ms;overflow:hidden;}
.main [class*="lines"],.footer-widget [class*="lines"]{display:-webkit-box!important;-webkit-box-orient:vertical;overflow:hidden;}
.lines2{-webkit-line-clamp:2;}
.multi-icons-link span{display:none;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
@media screen and (max-width:999px){
.ssc_post_grid.col2 .grid-item{width:50%;}
.ssc_post_grid.col2 .grid-item:nth-child(2n+1){clear:none;}
.ssc_post_grid.col2 .grid-item:nth-child(2n+1){clear:both;}
}
@media screen and (max-width:670px){
.ssc_post_grid .grid-item{float:none;}
}
@media screen and (max-width:600px){
.ssc_post_grid.col2 .grid-item{width:100%;}
.ssc_post_grid.col2 .grid-item:nth-child(2n+1){clear:none;}
}
@media screen and (max-width:480px){
.ssc_icon_box .bgr_icon i,.ssc_icon_box .c_img,.ssc_icon_box .c_text,.ssc_icon_box .bgr_no{margin-left:auto;margin-right:auto;}
.ssc_icon_box .icon_box{text-align:center;}
.ssc_icon_box.template1 .cont_box{padding-left:15px;}
}
.ssc_menu{position:relative;}
.ssc_menu{position:relative;}
.secretlab_menuline{position:relative;z-index:99;}
.secretlab_menuline:after{content:"";display:block;clear:both;width:100%;}
.secretlab_menuline.slmm-above{position:relative;}
.ssc_menu .slmm,.slmm *{margin:0;padding:0;outline:none;border:0;background:none;}
.slmm{position:relative;z-index:999;}
.slmm:after{content:"";display:block;clear:both;}
.slmm-respmenu{display:none;}
.slmm-respmenu .slm-open-menu-list{z-index:99;display:inline-block;padding:0 18px 0 18px;line-height:45px;box-sizing:border-box;}
.slmm li{position:relative;white-space:nowrap;list-style:none;}
.slmm li span{display:inline-block;cursor:pointer;}
.slmm li ul li ul li{white-space:normal;}
.slmm li ul li a span{display:inline;}
.slmm li a{display:block;text-decoration:none;cursor:pointer;transition:all 0.4s;}
.slmm li a i{text-decoration:none;}
.slmm li:hover a i,.slmm li a:hover i{text-decoration:none;}
.slmm li ul{overflow:hidden;}
.slmm li ul{position:absolute;z-index:1000;top:100%;left:-9999px;opacity:0;-o-transform-origin:0% 0%;-ms-transform-origin:0% 0%;-moz-transform-origin:0% 0%;-webkit-transform-origin:0% 0%;-o-transition:-o-transform 0.4s,opacity 0.4s;-ms-transition:-ms-transform 0.4s,opacity 0.4s;-moz-transition:-moz-transform 0.4s,opacity 0.4s;-webkit-transition:-webkit-transform 0.4s,opacity 0.4s;}
.slmm li ul:after{content:'';display:block;position:absolute;bottom:100%;left:0;width:100%;height:8px;background:transparent;clear:both;}
.slmm li:hover>ul.slm-sub-menu{left:0;opacity:1;-webkit-transform:translate(0,0);}
.slmm li:hover>ul.slmm-container.slm-submenu-pos-center{left:50%;}
.slmm .menu-item-icon{line-height:1;display:inline-block;}
.slmm li.slm-mega-block ul li a{white-space:normal;}
.slmm li li>ul{top:0;}
.slmm li li>ul.slm-sub-menu:after{top:0;right:100%;bottom:auto;left:auto;width:8px;height:100%;}
body.kc-css-system .slmm .slm-mega-block li.slmm-column{display:inline-block;vertical-align:top;height:initial;position:relative;}
.slm-mega-block .slmm-container>.slmm-column>ul.slmm-container.slm-sub-menu{position:relative;left:auto;width:100%;opacity:1;transform:none;-o-transform:none;-moz-transform:none;-webkit-transform:none;margin:0;padding:0;background-color:transparent;box-shadow:unset;}
.slmm li ul li ul.sub-sub-menu{width:240px;}
.slm-search-menu-item{z-index:999!important;}
.slm-search-icon{cursor:pointer;}
.slm-search-icon i{text-align:center;display:inline-block;}
.slm-search-block{position:fixed;top:-105%;left:0;width:100%;height:100%!important;margin:0;z-index:999999;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;}
.slm-search-block:before{content:"";position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;background:rgba(0,0,0,.73);width:100%;height:0;padding-bottom:100%;border-radius:100%;-webkit-transform:scale(.04),translateY(9999px);-ms-transform:scale(.04),translateY(9999px);transform:scale(.04),translateY(9999px);overflow:hidden;opacity:0;}
.slm-search-block form{left:50%;border-radius:5px!important;margin:0 auto;position:absolute;top:50%;font-weight:700;transform:scale(.5) translateX(-50%) translateY(-50%);max-width:800px;opacity:0;transition:all 0s linear;transition-delay:0s;}
body.kc-css-system .ssc_menu .slmm .slm-search-block:not(.opened) form{width:20%;}
.slm-search-block form input{border:none;background:transparent;border-bottom:2px solid rgba(255,255,255,.6);}
.slm-search-block form .slm-search-input{width:100%;color:#fff;}
.slm-search-submit-icon svg{width:26px;}
.slm-search-submit-icon{position:absolute;top:8px;right:2%;width:26px;}
.slm-search-submit{position:absolute!important;top:0;right:2%;width:21px;height:100%;cursor:pointer;opacity:0;border-radius:20px;padding:0!important;}
.slm-search-close svg{width:25px;height:25px;}
body .slmm span.slm-search-close{display:block;position:absolute;top:40px;right:40px;cursor:pointer;}
body .ssc_img_ef{/*overflow:hidden;*/position:relative;width:auto;transition:all 300ms ease-in;display:table;}
.ssc_img_ef:hover{z-index:9;}
.ssc_img_ef img{display:inline;transition:all 400ms;margin-bottom:-8px;}
.ssc_img_ef>div{overflow:hidden;display:table-cell;width:100%;height:100%;}
.ssc_img_ef.type1{display:table;}
.ssc_img_ef.type1>div{display:block;}
.ssc_team{overflow:hidden;position:relative;width:auto;transition:all 400ms ease-in;}
.ssc_team .content-socials a{transition:all 400ms ease-in;}
.ssc_team img{margin-bottom:-8px;transition:all 400ms;}
.ssc_team figure{overflow:hidden;position:relative;}
.ssc_team figure:before{content:"";display:block;position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;z-index:1;}
.ssc_team .content-title{margin:0;}
.ssc_team .content-subtitle{float:none;}
.ssc_team a i{text-decoration:none;}
.ssc_team i{transition:all 200ms;}
.ssc_team .islide{overflow:hidden;transition:all 400ms ease-in;z-index:2;position:relative;}
.ssc_team .islide>div{transition:all 400ms ease-in;}
.ssc_team.type8 .islide{position:absolute;z-index:1;bottom:0;top:0;left:0;width:100%;text-align:center;height:100%;transform:scale(0);}
.ssc_team.type8 .posa{position:absolute;z-index:1;bottom:0;left:0;width:100%;text-align:center;}
.ssc_team.type8:hover .islide{transform:scale(1);}
.ssc_team.type8 .content-title,.ssc_team.type8 .content-subtitle{text-align:left;}
.ssc_team.type8 .content-socials{padding:20px 15px 20px 0;text-align:right;}
.ssc_team.type8 .content-socials a{padding:0;color:#e84265;background-color:rgba(255,255,255,.85);width:40px;height:40px;display:inline-block;margin:0 8px 8px 0;line-height:40px;text-align:center;}
.ssc_team.type8 .content-socials a:hover{background-color:#fff;}
body .css_counter{overflow:hidden;position:relative;width:auto;transition:all 400ms;margin:0 auto;float:none;}
.css_counter .countbox{margin:0 auto;display:table;transition:all 300ms;}
.css_counter .countbox>span{display:table-cell;}
.css_counter .description{transition:all 400ms;}
.ssc_mltttl .wr p{margin:0;}
.ssc_mltttl>h3{display:inline-block;width:auto;position:relative;}
.ssc_mltttl>div{display:block;width:auto;position:relative;}
body .owl-carousel:after{content:"";clear:both;display:block;}
.ssc_carousel .owl-theme .owl-controls{margin-top:0;}
.ssc_carousel .owl-theme .owl-controls{position:relative;z-index:3;}
.owl-next,.owl-prev{transition:all 200ms;}
.kc-pricing-tables{position:relative;}
body .kc-pricing-tables .content-title{z-index:3;position:relative;background-color:transparent;}
.kc-pricing-price span{display:inline-block;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.owl-item:hover{z-index:5;}
.kc-col-container:after{content:"";display:block;clear:both;}
.sst-flex-row-inner{position:relative;z-index:1;min-height:30px;}
@media screen and (max-width:999px){
html body.kc-css-system .slmm{z-index:9;left:auto;}
html body.kc-css-system .slmm-mobile-hide .slmm{width:100vw!important;position:absolute;}
.slmm{box-shadow:0 10px 10px 0 rgba(0,0,0,.1);}
.slmm li ul:after{position:relative;}
.slmm-respmenu{padding:10px 0;}
.slmm-respmenu button{border-radius:0;}
.slmm-respmenu button i{font-size:22px;}
.slmm .slm-search-menu-item{width:100%;}
.slm-search-submit,.slm-search-submit-icon{right:25px;top:12px;}
.slm-search-block form{opacity:1;}
.slm-search-submit-icon svg{fill:#666!important;}
.slm-open-menu-list .slmm-icon-menu-shown{display:none!important;}
.slm-open-menu-list .slmm-icon-menu-hiden{display:inline-block!important;}
.slmm-respmenu{display:block;}
.slmm-mobile-hide .slmm{display:none!important;}
.slmm-mobile-hide .slmm{width:100%;clear:both;}
.slmm{float:none;margin-top:0;}
.slmm li{position:relative;white-space:nowrap;}
.slmm li:hover{height:auto!important;}
.slmm li.slm-mega-item:hover>ul.slm-sub-menu{top:100%;left:-9999px;opacity:0;}
.slmm li li:hover>ul.slm-sub-menu{top:0;opacity:0;left:0!important;position:relative!important;}
.slmm .slm-search-block{display:block!important;}
.slm-search-menu-item a.slm-search-icon,.slm-search-menu-item span.slm-search-close{display:none;}
.slm-search-block{display:block;position:relative;width:100%;}
.slm-search-block form{position:relative;width:100%!important;left:0;transform:none;padding:0;top:0;bottom:0;}
.slm-search-block form .slm-search-input{height:auto!important;}
}
@media screen and (max-width:768px){
.slmm li ul li a span{display:inline;}
.slmm li{white-space:normal;}
body.kc-css-system .slmm .slm-mega-block li.slmm-column{width:100%!important;display:block;float:none;}
}
.intl-tel-input{position:relative;display:inline-block;}
.intl-tel-input *{box-sizing:border-box;-moz-box-sizing:border-box;}
.intl-tel-input .hide{display:none;}
.intl-tel-input input,.intl-tel-input input[type=tel]{position:relative;z-index:0;margin-top:0!important;margin-bottom:0!important;padding-right:36px;margin-right:0;}
.intl-tel-input .flag-container{position:absolute;top:0;bottom:0;right:0;padding:1px;}
.intl-tel-input .selected-flag{z-index:1;position:relative;width:36px;height:100%;padding:0 0 0 8px;}
.intl-tel-input .selected-flag .iti-flag{position:absolute;top:0;bottom:0;margin:auto;}
.intl-tel-input .selected-flag .iti-arrow{position:absolute;top:50%;margin-top:-2px;right:6px;width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-top:4px solid #555;}
.intl-tel-input .country-list{position:absolute;z-index:2;list-style:none;text-align:left;padding:0;margin:0 0 0 -1px;box-shadow:1px 1px 4px rgba(0,0,0,.2);background-color:#fff;border:1px solid #CCC;white-space:nowrap;max-height:200px;overflow-y:scroll;}
.intl-tel-input .country-list .flag-box{display:inline-block;width:20px;}
@media (max-width:500px){
.intl-tel-input .country-list{white-space:normal;}
}
.intl-tel-input .country-list .divider{padding-bottom:5px;margin-bottom:5px;border-bottom:1px solid #CCC;}
.intl-tel-input .country-list .country{padding:5px 10px;}
.intl-tel-input .country-list .country .dial-code{color:#999;}
.intl-tel-input .country-list .flag-box,.intl-tel-input .country-list .country-name,.intl-tel-input .country-list .dial-code{vertical-align:middle;}
.intl-tel-input .country-list .flag-box,.intl-tel-input .country-list .country-name{margin-right:6px;}
.intl-tel-input.allow-dropdown input,.intl-tel-input.allow-dropdown input[type=tel]{padding-right:6px;padding-left:52px;margin-left:0;}
.intl-tel-input.allow-dropdown .flag-container{right:auto;left:0;}
.intl-tel-input.allow-dropdown .selected-flag{width:46px;}
.intl-tel-input.allow-dropdown .flag-container:hover{cursor:pointer;}
.intl-tel-input.allow-dropdown .flag-container:hover .selected-flag{background-color:rgba(0,0,0,.05);}
.iti-flag{width:20px;}
.iti-flag.be{width:18px;}
.iti-flag.ch{width:15px;}
.iti-flag.mc{width:19px;}
.iti-flag.ne{width:18px;}
.iti-flag.np{width:13px;}
.iti-flag.va{width:15px;}
@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (-o-min-device-pixel-ratio:2 / 1),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:192dpi),only screen and (min-resolution:2dppx){
.iti-flag{background-size:5630px 15px;}
}
.iti-flag.ad{height:14px;background-position:-22px 0;}
.iti-flag.ae{height:10px;background-position:-44px 0;}
.iti-flag.af{height:14px;background-position:-66px 0;}
.iti-flag.ag{height:14px;background-position:-88px 0;}
.iti-flag.ai{height:10px;background-position:-110px 0;}
.iti-flag.al{height:15px;background-position:-132px 0;}
.iti-flag.am{height:10px;background-position:-154px 0;}
.iti-flag.ao{height:14px;background-position:-176px 0;}
.iti-flag.ar{height:13px;background-position:-220px 0;}
.iti-flag.as{height:10px;background-position:-242px 0;}
.iti-flag.at{height:14px;background-position:-264px 0;}
.iti-flag.au{height:10px;background-position:-286px 0;}
.iti-flag.aw{height:14px;background-position:-308px 0;}
.iti-flag.ax{height:13px;background-position:-330px 0;}
.iti-flag.az{height:10px;background-position:-352px 0;}
.iti-flag.ba{height:10px;background-position:-374px 0;}
.iti-flag.bb{height:14px;background-position:-396px 0;}
.iti-flag.bd{height:12px;background-position:-418px 0;}
.iti-flag.be{height:15px;background-position:-440px 0;}
.iti-flag.bf{height:14px;background-position:-460px 0;}
.iti-flag.bg{height:12px;background-position:-482px 0;}
.iti-flag.bh{height:12px;background-position:-504px 0;}
.iti-flag.bi{height:12px;background-position:-526px 0;}
.iti-flag.bj{height:14px;background-position:-548px 0;}
.iti-flag.bl{height:14px;background-position:-570px 0;}
.iti-flag.bm{height:10px;background-position:-592px 0;}
.iti-flag.bn{height:10px;background-position:-614px 0;}
.iti-flag.bo{height:14px;background-position:-636px 0;}
.iti-flag.bq{height:14px;background-position:-658px 0;}
.iti-flag.br{height:14px;background-position:-680px 0;}
.iti-flag.bs{height:10px;background-position:-702px 0;}
.iti-flag.bt{height:14px;background-position:-724px 0;}
.iti-flag.bw{height:14px;background-position:-768px 0;}
.iti-flag.by{height:10px;background-position:-790px 0;}
.iti-flag.bz{height:14px;background-position:-812px 0;}
.iti-flag.ca{height:10px;background-position:-834px 0;}
.iti-flag.cc{height:10px;background-position:-856px 0;}
.iti-flag.cd{height:15px;background-position:-878px 0;}
.iti-flag.cf{height:14px;background-position:-900px 0;}
.iti-flag.cg{height:14px;background-position:-922px 0;}
.iti-flag.ch{height:15px;background-position:-944px 0;}
.iti-flag.ci{height:14px;background-position:-961px 0;}
.iti-flag.ck{height:10px;background-position:-983px 0;}
.iti-flag.cl{height:14px;background-position:-1005px 0;}
.iti-flag.cm{height:14px;background-position:-1027px 0;}
.iti-flag.cn{height:14px;background-position:-1049px 0;}
.iti-flag.co{height:14px;background-position:-1071px 0;}
.iti-flag.cr{height:12px;background-position:-1115px 0;}
.iti-flag.cu{height:10px;background-position:-1137px 0;}
.iti-flag.cv{height:12px;background-position:-1159px 0;}
.iti-flag.cw{height:14px;background-position:-1181px 0;}
.iti-flag.cx{height:10px;background-position:-1203px 0;}
.iti-flag.cy{height:13px;background-position:-1225px 0;}
.iti-flag.cz{height:14px;background-position:-1247px 0;}
.iti-flag.de{height:12px;background-position:-1269px 0;}
.iti-flag.dj{height:14px;background-position:-1313px 0;}
.iti-flag.dk{height:15px;background-position:-1335px 0;}
.iti-flag.dm{height:10px;background-position:-1357px 0;}
.iti-flag.do{height:13px;background-position:-1379px 0;}
.iti-flag.dz{height:14px;background-position:-1401px 0;}
.iti-flag.ec{height:14px;background-position:-1445px 0;}
.iti-flag.ee{height:13px;background-position:-1467px 0;}
.iti-flag.eg{height:14px;background-position:-1489px 0;}
.iti-flag.eh{height:10px;background-position:-1511px 0;}
.iti-flag.er{height:10px;background-position:-1533px 0;}
.iti-flag.es{height:14px;background-position:-1555px 0;}
.iti-flag.et{height:10px;background-position:-1577px 0;}
.iti-flag.fi{height:12px;background-position:-1621px 0;}
.iti-flag.fj{height:10px;background-position:-1643px 0;}
.iti-flag.fk{height:10px;background-position:-1665px 0;}
.iti-flag.fm{height:11px;background-position:-1687px 0;}
.iti-flag.fo{height:15px;background-position:-1709px 0;}
.iti-flag.fr{height:14px;background-position:-1731px 0;}
.iti-flag.ga{height:15px;background-position:-1753px 0;}
.iti-flag.gb{height:10px;background-position:-1775px 0;}
.iti-flag.gd{height:12px;background-position:-1797px 0;}
.iti-flag.ge{height:14px;background-position:-1819px 0;}
.iti-flag.gf{height:14px;background-position:-1841px 0;}
.iti-flag.gg{height:14px;background-position:-1863px 0;}
.iti-flag.gh{height:14px;background-position:-1885px 0;}
.iti-flag.gi{height:10px;background-position:-1907px 0;}
.iti-flag.gl{height:14px;background-position:-1929px 0;}
.iti-flag.gm{height:14px;background-position:-1951px 0;}
.iti-flag.gn{height:14px;background-position:-1973px 0;}
.iti-flag.gp{height:14px;background-position:-1995px 0;}
.iti-flag.gq{height:14px;background-position:-2017px 0;}
.iti-flag.gr{height:14px;background-position:-2039px 0;}
.iti-flag.gt{height:13px;background-position:-2083px 0;}
.iti-flag.gu{height:11px;background-position:-2105px 0;}
.iti-flag.gw{height:10px;background-position:-2127px 0;}
.iti-flag.gy{height:12px;background-position:-2149px 0;}
.iti-flag.hk{height:14px;background-position:-2171px 0;}
.iti-flag.hn{height:10px;background-position:-2215px 0;}
.iti-flag.hr{height:10px;background-position:-2237px 0;}
.iti-flag.ht{height:12px;background-position:-2259px 0;}
.iti-flag.hu{height:10px;background-position:-2281px 0;}
.iti-flag.id{height:14px;background-position:-2325px 0;}
.iti-flag.ie{height:10px;background-position:-2347px 0;}
.iti-flag.il{height:15px;background-position:-2369px 0;}
.iti-flag.im{height:10px;background-position:-2391px 0;}
.iti-flag.in{height:14px;background-position:-2413px 0;}
.iti-flag.io{height:10px;background-position:-2435px 0;}
.iti-flag.iq{height:14px;background-position:-2457px 0;}
.iti-flag.ir{height:12px;background-position:-2479px 0;}
.iti-flag.is{height:15px;background-position:-2501px 0;}
.iti-flag.it{height:14px;background-position:-2523px 0;}
.iti-flag.je{height:12px;background-position:-2545px 0;}
.iti-flag.jm{height:10px;background-position:-2567px 0;}
.iti-flag.jo{height:10px;background-position:-2589px 0;}
.iti-flag.jp{height:14px;background-position:-2611px 0;}
.iti-flag.ke{height:14px;background-position:-2633px 0;}
.iti-flag.kg{height:12px;background-position:-2655px 0;}
.iti-flag.kh{height:13px;background-position:-2677px 0;}
.iti-flag.ki{height:10px;background-position:-2699px 0;}
.iti-flag.km{height:12px;background-position:-2721px 0;}
.iti-flag.kn{height:14px;background-position:-2743px 0;}
.iti-flag.kp{height:10px;background-position:-2765px 0;}
.iti-flag.kr{height:14px;background-position:-2787px 0;}
.iti-flag.kw{height:10px;background-position:-2809px 0;}
.iti-flag.ky{height:10px;background-position:-2831px 0;}
.iti-flag.kz{height:10px;background-position:-2853px 0;}
.iti-flag.la{height:14px;background-position:-2875px 0;}
.iti-flag.lb{height:14px;background-position:-2897px 0;}
.iti-flag.lc{height:10px;background-position:-2919px 0;}
.iti-flag.li{height:12px;background-position:-2941px 0;}
.iti-flag.lk{height:10px;background-position:-2963px 0;}
.iti-flag.lr{height:11px;background-position:-2985px 0;}
.iti-flag.ls{height:14px;background-position:-3007px 0;}
.iti-flag.lt{height:12px;background-position:-3029px 0;}
.iti-flag.lu{height:12px;background-position:-3051px 0;}
.iti-flag.lv{height:10px;background-position:-3073px 0;}
.iti-flag.ly{height:10px;background-position:-3095px 0;}
.iti-flag.ma{height:14px;background-position:-3117px 0;}
.iti-flag.mc{height:15px;background-position:-3139px 0;}
.iti-flag.md{height:10px;background-position:-3160px 0;}
.iti-flag.me{height:10px;background-position:-3182px 0;}
.iti-flag.mf{height:14px;background-position:-3204px 0;}
.iti-flag.mg{height:14px;background-position:-3226px 0;}
.iti-flag.mh{height:11px;background-position:-3248px 0;}
.iti-flag.mk{height:10px;background-position:-3270px 0;}
.iti-flag.ml{height:14px;background-position:-3292px 0;}
.iti-flag.mm{height:14px;background-position:-3314px 0;}
.iti-flag.mn{height:10px;background-position:-3336px 0;}
.iti-flag.mo{height:14px;background-position:-3358px 0;}
.iti-flag.mp{height:10px;background-position:-3380px 0;}
.iti-flag.mq{height:14px;background-position:-3402px 0;}
.iti-flag.mr{height:14px;background-position:-3424px 0;}
.iti-flag.ms{height:10px;background-position:-3446px 0;}
.iti-flag.mt{height:14px;background-position:-3468px 0;}
.iti-flag.mu{height:14px;background-position:-3490px 0;}
.iti-flag.mv{height:14px;background-position:-3512px 0;}
.iti-flag.mw{height:14px;background-position:-3534px 0;}
.iti-flag.mx{height:12px;background-position:-3556px 0;}
.iti-flag.my{height:10px;background-position:-3578px 0;}
.iti-flag.mz{height:14px;background-position:-3600px 0;}
.iti-flag.na{height:14px;background-position:-3622px 0;}
.iti-flag.nc{height:10px;background-position:-3644px 0;}
.iti-flag.ne{height:15px;background-position:-3666px 0;}
.iti-flag.nf{height:10px;background-position:-3686px 0;}
.iti-flag.ng{height:10px;background-position:-3708px 0;}
.iti-flag.ni{height:12px;background-position:-3730px 0;}
.iti-flag.nl{height:14px;background-position:-3752px 0;}
.iti-flag.no{height:15px;background-position:-3774px 0;}
.iti-flag.np{height:15px;background-position:-3796px 0;}
.iti-flag.nr{height:10px;background-position:-3811px 0;}
.iti-flag.nu{height:10px;background-position:-3833px 0;}
.iti-flag.nz{height:10px;background-position:-3855px 0;}
.iti-flag.om{height:10px;background-position:-3877px 0;}
.iti-flag.pa{height:14px;background-position:-3899px 0;}
.iti-flag.pe{height:14px;background-position:-3921px 0;}
.iti-flag.pf{height:14px;background-position:-3943px 0;}
.iti-flag.pg{height:15px;background-position:-3965px 0;}
.iti-flag.ph{height:10px;background-position:-3987px 0;}
.iti-flag.pk{height:14px;background-position:-4009px 0;}
.iti-flag.pl{height:13px;background-position:-4031px 0;}
.iti-flag.pm{height:14px;background-position:-4053px 0;}
.iti-flag.pr{height:14px;background-position:-4097px 0;}
.iti-flag.ps{height:10px;background-position:-4119px 0;}
.iti-flag.pt{height:14px;background-position:-4141px 0;}
.iti-flag.pw{height:13px;background-position:-4163px 0;}
.iti-flag.py{height:11px;background-position:-4185px 0;}
.iti-flag.qa{height:8px;background-position:-4207px 0;}
.iti-flag.re{height:14px;background-position:-4229px 0;}
.iti-flag.ro{height:14px;background-position:-4251px 0;}
.iti-flag.rs{height:14px;background-position:-4273px 0;}
.iti-flag.ru{height:14px;background-position:-4295px 0;}
.iti-flag.rw{height:14px;background-position:-4317px 0;}
.iti-flag.sa{height:14px;background-position:-4339px 0;}
.iti-flag.sb{height:10px;background-position:-4361px 0;}
.iti-flag.sc{height:10px;background-position:-4383px 0;}
.iti-flag.sd{height:10px;background-position:-4405px 0;}
.iti-flag.se{height:13px;background-position:-4427px 0;}
.iti-flag.sg{height:14px;background-position:-4449px 0;}
.iti-flag.sh{height:10px;background-position:-4471px 0;}
.iti-flag.si{height:10px;background-position:-4493px 0;}
.iti-flag.sj{height:15px;background-position:-4515px 0;}
.iti-flag.sk{height:14px;background-position:-4537px 0;}
.iti-flag.sl{height:14px;background-position:-4559px 0;}
.iti-flag.sm{height:15px;background-position:-4581px 0;}
.iti-flag.sn{height:14px;background-position:-4603px 0;}
.iti-flag.so{height:14px;background-position:-4625px 0;}
.iti-flag.sr{height:14px;background-position:-4647px 0;}
.iti-flag.ss{height:10px;background-position:-4669px 0;}
.iti-flag.st{height:10px;background-position:-4691px 0;}
.iti-flag.sv{height:12px;background-position:-4713px 0;}
.iti-flag.sx{height:14px;background-position:-4735px 0;}
.iti-flag.sy{height:14px;background-position:-4757px 0;}
.iti-flag.sz{height:14px;background-position:-4779px 0;}
.iti-flag.tc{height:10px;background-position:-4823px 0;}
.iti-flag.td{height:14px;background-position:-4845px 0;}
.iti-flag.tg{height:13px;background-position:-4889px 0;}
.iti-flag.th{height:14px;background-position:-4911px 0;}
.iti-flag.tj{height:10px;background-position:-4933px 0;}
.iti-flag.tk{height:10px;background-position:-4955px 0;}
.iti-flag.tl{height:10px;background-position:-4977px 0;}
.iti-flag.tm{height:14px;background-position:-4999px 0;}
.iti-flag.tn{height:14px;background-position:-5021px 0;}
.iti-flag.to{height:10px;background-position:-5043px 0;}
.iti-flag.tr{height:14px;background-position:-5065px 0;}
.iti-flag.tt{height:12px;background-position:-5087px 0;}
.iti-flag.tv{height:10px;background-position:-5109px 0;}
.iti-flag.tw{height:14px;background-position:-5131px 0;}
.iti-flag.tz{height:14px;background-position:-5153px 0;}
.iti-flag.ua{height:14px;background-position:-5175px 0;}
.iti-flag.ug{height:14px;background-position:-5197px 0;}
.iti-flag.us{height:11px;background-position:-5241px 0;}
.iti-flag.uy{height:14px;background-position:-5263px 0;}
.iti-flag.uz{height:10px;background-position:-5285px 0;}
.iti-flag.va{height:15px;background-position:-5307px 0;}
.iti-flag.vc{height:14px;background-position:-5324px 0;}
.iti-flag.ve{height:14px;background-position:-5346px 0;}
.iti-flag.vg{height:10px;background-position:-5368px 0;}
.iti-flag.vi{height:14px;background-position:-5390px 0;}
.iti-flag.vn{height:14px;background-position:-5412px 0;}
.iti-flag.vu{height:12px;background-position:-5434px 0;}
.iti-flag.wf{height:14px;background-position:-5456px 0;}
.iti-flag.ws{height:10px;background-position:-5478px 0;}
.iti-flag.xk{height:15px;background-position:-5500px 0;}
.iti-flag.ye{height:14px;background-position:-5522px 0;}
.iti-flag.yt{height:14px;background-position:-5544px 0;}
.iti-flag.za{height:14px;background-position:-5566px 0;}
.iti-flag.zm{height:14px;background-position:-5588px 0;}
.iti-flag.zw{height:10px;background-position:-5610px 0;}
.iti-flag{width:20px;height:15px;box-shadow:0 0 1px 0 #888;background-image:url(../../assets/images/flags.png);background-repeat:no-repeat;background-color:#DBDBDB;background-position:20px 0;}
@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (-o-min-device-pixel-ratio:2 / 1),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:192dpi),only screen and (min-resolution:2dppx){
.iti-flag{background-image:url(../../assets/images/flags.png);}
}
.iti-flag.np{background-color:transparent;}
}
/*! CSS Used from: Embedded */
#rev_slider_33_1_wrapper rs-loader.spinner3 div{background-color:#ffffff!important;}
/*! CSS Used from: Embedded */
@media only screen and (min-width: 1000px) and (max-width: 5000px){
body.kc-css-system .kc-css-58692{width:50%;}
body.kc-css-system .kc-css-428528{width:31.23%;}
body.kc-css-system .kc-css-569481{width:68.68%;}
body.kc-css-system .kc-css-636382{width:29.37%;}
body.kc-css-system .kc-css-316608{width:19.62%;}
body.kc-css-system .kc-css-743633{width:28.17%;}
body.kc-css-system .kc-css-385138{width:51.37%;}
body.kc-css-system .kc-css-605100{width:20.33%;}
}
.kc-css-17768 .kc_column{padding-left:0px;padding-right:0px;}
body.kc-css-system .kc-css-17768{background:#21242e;padding-bottom:5px;}
body.kc-css-system .kc-css-67261{margin-right:0px;margin-left:0px;padding-top:20px;width:100%;}
.kc-css-67261 >.kc_column_inner{padding-left:0px;padding-right:0px;}
body.kc-css-system .kc-css-237008{text-align:left;padding-left:15px;}
body.kc-css-system .kc-css-237008 .icon_box{padding-top:5px;}
body.kc-css-system .kc-css-237008 .bgr_no{line-height:90px;}
body.kc-css-system .kc-css-237008 .bgr_no{text-align:center;}
body.kc-css-system .kc-css-237008 .title,body.kc-css-system .kc-css-237008 .title a{color:#ffffff;font-size:16px;line-height:29px;font-weight:400;font-family:Catamaran;text-transform:none;text-decoration:none;margin-top:-3px;}
body.kc-css-system .kc-css-237008 .cont_box{text-align:left;padding-left:8px;}
body.kc-css-system .kc-css-894773{text-align:left;padding-left:15px;}
body.kc-css-system .kc-css-894773 .icon_box{padding-top:5px;}
body.kc-css-system .kc-css-894773 .bgr_no{line-height:90px;}
body.kc-css-system .kc-css-894773 .bgr_no{text-align:center;}
body.kc-css-system .kc-css-894773 .title,body.kc-css-system .kc-css-894773 .title a{color:#ffffff;font-size:16px;line-height:29px;font-weight:400;font-family:Catamaran;text-transform:none;text-decoration:none;margin-top:-3px;}
body.kc-css-system .kc-css-894773 .cont_box .description{color:#646a70;font-size:16px;display:none!important;margin-bottom:15px;}
body.kc-css-system .kc-css-894773 .cont_box .description{line-height:22px;}
body.kc-css-system .kc-css-894773 .cont_box{text-align:left;padding-left:8px;}
body.kc-css-system .kc-css-636382{text-align:right;}
body.kc-css-system .kc-css-20672{text-align:right;display:block;float:right;margin-right:-35px;padding-top:20px;}
body.kc-css-system .kc-css-20672 .icon_box{padding-top:5px;}
body.kc-css-system .kc-css-20672 .bgr_no{line-height:90px;}
body.kc-css-system .kc-css-20672 .bgr_no{text-align:center;}
body.kc-css-system .kc-css-20672 .title{color:#ffffff;font-size:16px;line-height:29px;font-weight:400;font-family:Catamaran;text-align:right;text-transform:none;margin-top:-3px;}
body.kc-css-system .kc-css-20672 .cont_box{text-align:right;padding-left:8px;}
body.kc-css-system .kc-css-102986 i{color:#ffffff;font-size:17px;}
body.kc-css-system .kc-css-102986 a{background-color:rgba(255, 255, 255, 0);text-align:right;width:37px;height:35px;border-radius:50% 50% 50% 50%;padding-top:10px;padding-right:0px;padding-left:20px;margin-right:2px;}
body.kc-css-system .kc-css-102986 a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-102986{text-align:right;padding-top:9px;padding-right:10px;padding-left:20px;margin-right:0px;}
body.kc-css-system .kc-css-182427{background:#151823;padding-top:19px;padding-bottom:19px;border-bottom:1px solid rgba(255, 255, 255, 0.20);}
body.kc-css-system .kc-css-931477{text-align:left;padding-top:15px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-914487 .slmm-respmenu{text-align:right;}
body.kc-css-system .kc-css-914487 .slmm-respmenu .slm-open-menu-list{background:rgba(255, 255, 255, 0);color:#ED7D31;border:2px solid rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-914487 .slmm-respmenu i{font-size:27px;line-height:58px;}
body.kc-css-system .kc-css-914487 .slm-open-menu-list i{color:#ffffff;}
body.kc-css-system .kc-css-914487 .slmm{text-align:left;}
body.kc-css-system .kc-css-914487 .slmm,body.kc-css-system .kc-css-914487 .slmm-respmenu{margin-top:7px;}
body.kc-css-system .kc-css-914487 .slmm li{display:inline-block;text-align:center;}
body.kc-css-system .kc-css-914487 .slmm li a{font-size:18px;line-height:29px;color:#ffffff;font-family:Catamaran;font-weight:500;text-transform:none;;padding:20px 16px 20px 15px;}
body.kc-css-system .kc-css-914487 .slmm li.current-menu-item a,body.kc-css-system .kc-css-914487 .slmm li.current-menu-item span{color:#ED7D31;}
body.kc-css-system .kc-css-914487 .slmm li a span{text-decoration:none;}
body.kc-css-system .kc-css-914487 .slmm li i{display:none;}
body.kc-css-system .kc-css-914487 .slmm li .caret{font-size:9px;color:#ffffff;display:inline-block;margin-left:10px;}
body.kc-css-system .kc-css-914487 .slm-mega-item .slm-search-icon i.menu-item-icon{font-size:14px;color:#ffffff;display:inline-block;padding-left:35px;}
body.kc-css-system .kc-css-914487 .slm-mega-item .slm-search-icon{padding-right:0px;}
body.kc-css-system .kc-css-914487 .slmm .slm-search-block .slm-search-input{font-size:20px;border-radius:0px 0px 0px 0px;padding-right:30px;padding-left:30px;margin-top:0px;margin-bottom:0px;}
body.kc-css-system .kc-css-914487 .slmm .slm-search-block form{width:100%!important;margin-top:15px;margin-bottom:5px;}
body.kc-css-system .kc-css-914487 .slmm .slm-search-block .slm-search-close{color:#dd3333;}
body.kc-css-system .kc-css-914487 .slmm .slm-search-block{background:rgba(0, 0, 0, 0.80);}
body.kc-css-system .kc-css-914487 .slmm li ul{text-align:left;float:left;padding-top:4px;padding-right:0px;padding-left:0px;background:#ffffff;box-shadow:0px 0px 5px 0px rgba(0,0,0,0.30);border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-914487 .slmm li ul li{display:block;float:left;text-align:left;height:100%;width:100%;margin-right:0px;margin-left:0px;}
body.kc-css-system .kc-css-914487 .slmm li ul li a{font-size:16px;line-height:14px;color:#666666;font-family:Catamaran;font-weight:400;text-transform:full-size-kana;background:rgba(255, 255, 255, 0);border-bottom:2px solid #f8f8f8;;padding-right:35px;padding-left:35px;}
body.kc-css-system .kc-css-914487 .slmm li ul li.current-menu-item a,body.kc-css-system .kc-css-914487 .slmm li ul li.current-menu-item span{color:#ED7D31;}
body.kc-css-system .kc-css-914487 .slm-sub-menu li:last-child > a{border-bottom:2px solid rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-914487 .slmm li ul li a i{font-size:15px;}
body.kc-css-system .kc-css-914487 .slmm li ul li a i{height:15px;width:15px;color:#ED7D31;margin-right:10px;}
body.kc-css-system .kc-css-914487 .slmm li ul li ul{background:#ffffff;}
body.kc-css-system .kc-css-914487 .slmm li.slmm-column{text-align:center;}
body.kc-css-system .kc-css-914487 .slmm-respmenu .slm-open-menu-list:hover{background:rgba(255, 255, 255, 0);color:#ED7D31;border:2px solid rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-914487 .slm-open-menu-list:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-914487 .slmm li a:hover{color:#ED7D31;border-bottom:0px solid #000000;}
body.kc-css-system .kc-css-914487 .slmm li.current-menu-item a:hover{color:#ED7D31;}
body.kc-css-system .kc-css-914487 .slmm li ul li a:hover{color:#222222;background:rgba(243, 84, 68, 0);border-bottom:2px solid #ED7D31;}
body.kc-css-system .kc-css-713471.ssc_btn{text-align:right;padding-top:15px;}
body.kc-css-system .kc-css-713471 .ssc_button{color:#ffffff;background-color:rgba(255, 255, 255, 0);font-family:Catamaran;font-size:16px;line-height:22px;font-weight:500;text-decoration:none;border:2px solid #ED7D31;border-radius:50px 50px 50px 50px;padding:10px 50px 10px 50px;}
body.kc-css-system .kc-css-713471{text-align:center;}
body.kc-css-system .kc-css-713471 .ssc_button:hover{color:#ffffff;background-color:#ED7D31;border:2px solid #ED7D31;}
@media only screen and (max-width: 768px){
body.kc-css-system .kc-css-20672{text-align:left;float:left;}
}
@media only screen and (max-width: 1024px){
body.kc-css-system .kc-css-17768{height:100%;}
body.kc-css-system .kc-css-58692{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-428528{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-569481{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-636382{width:25%;}
body.kc-css-system .kc-css-316608{width:25%;}
body.kc-css-system .kc-css-743633{width:18%;}
body.kc-css-system .kc-css-385138{width:60%;}
body.kc-css-system .kc-css-605100{width:22%;}
}
@media only screen and (max-width: 999px){
body.kc-css-system .kc-css-58692{width:50%;}
body.kc-css-system .kc-css-58692{margin-left:0%;width:55%;}
body.kc-css-system .kc-css-428528{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-636382{width:50%;}
body.kc-css-system .kc-css-636382{width:13%;}
body.kc-css-system .kc-css-316608{width:50%;}
body.kc-css-system .kc-css-316608{margin-left:0%;width:32%;}
body.kc-css-system .kc-css-743633{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-385138{padding-right:0px;}
body.kc-css-system .kc-css-385138{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-914487.ssc_menu{margin-top:0px;}
body.kc-css-system .kc-css-914487 .slmm,body.kc-css-system .kc-css-914487 .slmm-respmenu{margin-top:0px;}
body.kc-css-system .kc-css-914487 .slmm{background:#ffffff;padding:10px 15px 30px 15px;}
body.kc-css-system .kc-css-914487 .slmm li{display:block;float:none;text-align:left;background:#ffffff;padding-right:5px;padding-left:5px;}
body.kc-css-system .kc-css-914487 .slmm li a{font-size:20px;color:#666666;padding-top:15px;padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-914487 .slmm .slm-search-block{background:rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-914487 .slmm li ul li{background:rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-605100{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-713471.ssc_btn{margin-top:-80px;margin-left:-10%;}
}
@media only screen and (max-width: 767px){
body.kc-css-system .kc-css-58692{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-67261{padding-top:10px;}
body.kc-css-system .kc-css-428528{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-569481{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-636382{padding-left:15px;}
body.kc-css-system .kc-css-636382{margin-left:0%;width:30%;}
body.kc-css-system .kc-css-316608{margin-left:0%;width:70%;}
body.kc-css-system .kc-css-102986 a{text-align:left;}
body.kc-css-system .kc-css-102986{text-align:left;}
body.kc-css-system .kc-css-385138{padding-right:0px;padding-left:15px;}
}
@media only screen and (max-width: 479px){
body.kc-css-system .kc-css-58692{width:100%;}
body.kc-css-system .kc-css-58692{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-67261{padding-left:15px;}
body.kc-css-system .kc-css-428528{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-237008{padding-left:0px;}
body.kc-css-system .kc-css-569481{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-894773{padding-left:0px;}
body.kc-css-system .kc-css-636382{padding-top:0px!important;width:100%;}
body.kc-css-system .kc-css-636382{margin-left:0%;width:30%;}
body.kc-css-system .kc-css-20672{padding-top:0px;padding-left:0px;}
body.kc-css-system .kc-css-316608{width:100%;}
body.kc-css-system .kc-css-316608{margin-left:0%;width:70%;}
body.kc-css-system .kc-css-102986 a{padding-top:0px;padding-left:0px;}
body.kc-css-system .kc-css-102986{padding-top:0px;}
body.kc-css-system .kc-css-743633{margin-left:0%;width:70%;}
body.kc-css-system .kc-css-385138{margin-left:0%;width:30%;}
body.kc-css-system .kc-css-605100{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-713471.ssc_btn{margin-top:0px;margin-left:0px;}
body.kc-css-system .kc-css-713471 .ssc_button{text-align:center;width:100%;}
}
@media only screen and (min-width: 1000px) and (max-width: 5000px){
body.kc-css-system .kc-css-740572{width:33.33%;}
body.kc-css-system .kc-css-44976{width:30.98%;}
body.kc-css-system .kc-css-3020658{width:68.95%;}
body.kc-css-system .kc-css-2877056{width:33.33%;}
body.kc-css-system .kc-css-660449{width:33.33%;}
body.kc-css-system .kc-css-3640123{width:63.55%;}
body.kc-css-system .kc-css-3332474{width:36.44%;}
}
body.kc-css-system .kc-css-4360734{background:#151823;padding-top:90px;padding-bottom:70px;}
body.kc-css-system .kc-css-740572{padding-bottom:0px;}
body.kc-css-system .kc-css-740572{padding-right:5%;}
body.kc-css-system .kc-css-2289599.ssc_mltttl .wr{color:#ffffff;font-size:22px;font-weight:700;font-family:Montserrat;text-transform:none;margin-top:0px;margin-bottom:0px;}
body.kc-css-system .kc-css-2289599{margin-bottom:28px;padding-bottom:28px;border-bottom:1px solid rgba(255, 255, 255, 0.20);;display:inline-block;}
body.kc-css-system .kc-css-2289599 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;}
body.kc-css-system .kc-css-2289599 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:17px;margin-right:-4px;}
body.kc-css-system .kc-css-207586,body.kc-css-system .kc-css-207586 p{color:#7e8399;font-size:18px;line-height:26px;font-weight:400;}
body.kc-css-system .kc-css-207586 p{text-align:left;margin-top:0px;margin-bottom:0px;}
body.kc-css-system .kc-css-207586{padding-top:5px;padding-bottom:18px;}
body.kc-css-system .kc-css-1448524{text-align:left;width:100%;margin-left:-3px;}
body.kc-css-system .kc-css-1448524 .icon_box{padding-top:5px;}
body.kc-css-system .kc-css-1448524 .bgr_no{line-height:90px;}
body.kc-css-system .kc-css-1448524 .bgr_no{text-align:center;}
body.kc-css-system .kc-css-1448524 .title,body.kc-css-system .kc-css-1448524 .title a{color:#ffffff;font-size:16px;line-height:29px;font-weight:400;font-family:Catamaran;text-transform:none;text-decoration:none;margin-top:-3px;}
body.kc-css-system .kc-css-1448524 .cont_box{text-align:left;padding-left:8px;}
body.kc-css-system .kc-css-2802498{text-align:left;width:100%;margin-left:-3px;}
body.kc-css-system .kc-css-2802498 .icon_box{padding-top:5px;}
body.kc-css-system .kc-css-2802498 .bgr_no{line-height:90px;}
body.kc-css-system .kc-css-2802498 .bgr_no{text-align:center;}
body.kc-css-system .kc-css-2802498 .title,body.kc-css-system .kc-css-2802498 .title a{color:#ffffff;font-size:16px;line-height:29px;font-weight:400;font-family:Catamaran;text-transform:none;text-decoration:none;margin-top:-3px;}
body.kc-css-system .kc-css-2802498 .cont_box .description{color:#646a70;font-size:16px;display:none!important;margin-bottom:15px;}
body.kc-css-system .kc-css-2802498 .cont_box .description{line-height:22px;}
body.kc-css-system .kc-css-2802498 .cont_box{text-align:left;padding-left:8px;}
body.kc-css-system .kc-css-2899979{margin-top:-8px;}
body.kc-css-system .kc-css-44976{padding-right:0px;}
body.kc-css-system .kc-css-63307{text-align:left;margin-left:-3px;padding-top:10px;}
body.kc-css-system .kc-css-63307 .icon_box{padding-top:5px;}
body.kc-css-system .kc-css-63307 .bgr_no{line-height:90px;}
body.kc-css-system .kc-css-63307 .bgr_no{text-align:center;}
body.kc-css-system .kc-css-63307 .title{color:#ffffff;font-size:16px;line-height:29px;font-weight:400;font-family:Catamaran;text-align:left;text-transform:none;margin-top:-3px;}
body.kc-css-system .kc-css-63307 .cont_box{text-align:right;padding-left:8px;}
body.kc-css-system .kc-css-3020658{padding-left:0px;}
body.kc-css-system .kc-css-1062868 i{color:#ffffff;font-size:17px;line-height:20px;}
body.kc-css-system .kc-css-1062868 a{background-color:rgba(27, 32, 50, 0);text-align:center;width:35px;height:35px;border-radius:40px 40px 40px 40px;margin-right:5px;}
body.kc-css-system .kc-css-1062868 a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-1062868{text-align:left;padding-left:0px;margin-top:-1px;margin-left:3px;}
body.kc-css-system .kc-css-2877056{padding-right:3%;padding-left:3%;}
body.kc-css-system .kc-css-1067417.ssc_mltttl .wr{color:#ffffff;font-size:22px;font-weight:700;font-family:Montserrat;text-transform:none;margin-top:0px;margin-bottom:0px;}
body.kc-css-system .kc-css-1067417{margin-bottom:28px;padding-bottom:28px;border-bottom:1px solid rgba(255, 255, 255, 0.20);;display:inline-block;}
body.kc-css-system .kc-css-1067417 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;}
body.kc-css-system .kc-css-1067417 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:17px;margin-right:-4px;}
body.kc-css-system .kc-css-3740499{padding-right:3%;}
body.kc-css-system .kc-css-3740499 .grid-item{margin-bottom:25px;}
body.kc-css-system .kc-css-3740499 .grid-item .body{margin-top:0px;margin-left:0px;padding:0px 0px 0px 0px;}
body.kc-css-system .kc-css-3740499 .grid-item .title a{background:rgba(153, 153, 153, 0);color:#ffffff;font-size:18px;line-height:28px;font-weight:400;font-family:Catamaran;text-transform:none;float:none;margin-bottom:0px;padding-top:3px;}
body.kc-css-system .kc-css-3740499 .grid-item .meta{font-size:14px;margin-bottom:0px;}
body.kc-css-system .kc-css-3740499 .grid-item .meta i{color:#768188;font-size:0px;margin-left:-8px;}
body.kc-css-system .kc-css-3740499 .grid-item .date{color:#7e8399;font-size:14px;line-height:26px;font-weight:400;font-family:Catamaran;}
body.kc-css-system .kc-css-3740499 .grid-item .title a:hover{color:#ED7D31;}
body.kc-css-system .kc-css-660449{padding-left:4.5%;}
body.kc-css-system .kc-css-4015343.ssc_mltttl .wr{color:#ffffff;font-size:22px;font-weight:700;font-family:Montserrat;text-transform:none;margin-top:0px;margin-bottom:0px;}
body.kc-css-system .kc-css-4015343{margin-bottom:24px;padding-bottom:28px;border-bottom:1px solid rgba(255, 255, 255, 0.20);;display:inline-block;}
body.kc-css-system .kc-css-4015343 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;}
body.kc-css-system .kc-css-4015343 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:17px;margin-right:-4px;}
body.kc-css-system .kc-css-2035853,body.kc-css-system .kc-css-2035853 p{color:#7e8399;font-size:18px;line-height:26px;font-weight:400;}
body.kc-css-system .kc-css-2035853 p{text-align:left;margin-top:0px;margin-bottom:0px;}
body.kc-css-system .kc-css-2035853{padding-top:5px;padding-bottom:25px;}
body.kc-css-system .kc-css-4334113{display:flex;width:100%;max-width:460px;padding-left:0px;}
body.kc-css-system .kc-css-4334113 .caldera-grid .row{margin-right:0px;margin-left:0px;}
body.kc-css-system .kc-css-4334113 .caldera-grid .row > div{display:flex;opacity:1;padding-right:0px;padding-left:0px;}
body.kc-css-system .kc-css-4334113 label{color:#949494;}
body.kc-css-system .kc-css-4334113 input{color:#ffffff;background:rgba(116, 131, 190, 0);font-size:16px;line-height:48px;text-align:center;width:100%;height:48px;border:1px solid #9296a4;border-radius:77px 77px 77px 77px;margin-bottom:15px;padding-top:0px;padding-bottom:0px;padding-left:20px;}
body.kc-css-system .kc-css-4334113 input::-webkit-input-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-4334113 input::-moz-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-4334113 input:-moz-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-4334113 input:-ms-input-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-4334113 .caldera-grid input.btn{color:#ffffff;background:rgba(255, 255, 255, 0);width:100%;font-size:16px;line-height:45px;font-weight:500;text-align:center;text-transform:full-size-kana;border:2px solid #ED7D31;margin-top:5px;padding-right:30px;padding-left:30px;}
body.kc-css-system .kc-css-4334113 .caldera-grid input.btn:hover{color:#ffffff;background:#ED7D31;border:2px solid #ED7D31;}
body.kc-css-system .kc-css-4334113 input:focus{box-shadow:none;border:1px solid #ED7D31;}
body.kc-css-system .kc-css-1439105{text-align:left;display:none;}
body.kc-css-system .kc-css-1439105 label{display:inline-block;float:left;}
body.kc-css-system .kc-css-1439105 input.search-field{display:inline;border:2px solid #cccccc;}
body.kc-css-system .kc-css-1439105 .search-submit{color:#383838;font-size:14px;line-height:44px;font-weight:700;text-transform:uppercase;display:inline-block;background:#e8e8e8;padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-1439105 i{margin-right:5px;}
body.kc-css-system .kc-css-3914937{background:#1b2032;padding-top:10px;padding-bottom:10px;}
body.kc-css-system .kc-css-3141476,body.kc-css-system .kc-css-3141476 p{color:#7e8399;font-size:14px;line-height:20px;font-weight:400;text-transform:full-size-kana;}
body.kc-css-system .kc-css-3141476 p{text-align:left;margin-top:15px;margin-bottom:15px;}
body.kc-css-system .kc-css-3141476 a{color:#7e8399;}
body.kc-css-system .kc-css-3332474{padding-right:3%;}
body.kc-css-system .kc-css-4235042,body.kc-css-system .kc-css-4235042 p{color:#7e8399;font-size:14px;line-height:20px;font-weight:400;text-transform:full-size-kana;}
body.kc-css-system .kc-css-4235042 p{text-align:right;margin-top:15px;margin-right:-15px;margin-bottom:15px;}
body.kc-css-system .kc-css-4235042 a{color:#7e8399;}
@media only screen and (max-width: 768px){
body.kc-css-system .kc-css-4334113 .caldera-grid input.btn{margin-left:0px;}
}
@media only screen and (max-width: 667px){
body.kc-css-system .kc-css-4334113 .caldera-grid input.btn{text-align:center;margin-left:0px;padding-right:30px;padding-left:30px;}
}
@media only screen and (max-width: 1024px){
body.kc-css-system .kc-css-740572{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-2877056{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-660449{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-660449{padding-top:35px;padding-left:15px;}
}
@media only screen and (max-width: 999px){
body.kc-css-system .kc-css-740572{width:100%;}
body.kc-css-system .kc-css-2877056{padding-top:40px;padding-left:15px;}
body.kc-css-system .kc-css-2877056{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-660449{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-660449{padding-top:20px;padding-left:15px;}
body.kc-css-system .kc-css-3640123{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-3141476 p{text-align:left;}
body.kc-css-system .kc-css-3332474{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-4235042 p{text-align:left;}
}
@media only screen and (max-width: 767px){
body.kc-css-system .kc-css-44976{width:30%;}
body.kc-css-system .kc-css-3020658{width:70%;}
body.kc-css-system .kc-css-3332474{padding-right:15px;}
}
@media only screen and (max-width: 479px){
body.kc-css-system .kc-css-740572{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-1448524{padding-left:0px;}
body.kc-css-system .kc-css-2802498{padding-left:0px;}
body.kc-css-system .kc-css-63307{padding-left:0px;}
body.kc-css-system .kc-css-2877056{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-4334113 .caldera-grid input.btn{margin-left:0px;}
}
.holayout5 .grid-item .date,.holayout5 .grid-item .post-author{display:inline-block;position:relative;}
.holayout5 .rm::after,.holayout5 .grid-item .date::after,.holayout5 .grid-item .post-author::after{content:'';display:inline-block;width:5px;border-radius:3px;height:5px;background-color:rgba(243,84,68,1);margin:6px 0 0 17px;float:right;transition:all 200ms ease-in;}
.holayout5 .grid-item .date:hover:after,.holayout5 .grid-item .post-author:hover:after{width:20px;}
.holayout5 .rm::after{margin:4px 0 0 17px;width:20px;}
.holayout5 .rm:hover:after{width:40px;}
.search-form input{color:#7E8399;font-size:17px;background:rgba(116, 131, 190, 0);border:1px solid rgba(126, 131, 153, 0.20);padding-left:30px;}
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
p.t3,p.t4,p.t5{font-size:20px;line-height:26px;padding-top:20px!important;}
.css_counter .description{display:none!important;}
.css_counter{padding-bottom:0px!important;}
body .owl-theme .owl-controls .owl-buttons > div{padding:0;}
}
/*! CSS Used from: Embedded */
.slmm li#nav-menu-item-4618 > a{display:none;}
.slmm li#nav-menu-item-4658 > a{display:none;}
.slmm li#nav-menu-item-4660 > a{display:none;}
.slmm li#nav-menu-item-4619 > a{display:none;}
.slmm li#nav-menu-item-4635 > a{display:none;}
.slmm li#nav-menu-item-4637 > a{display:none;}
.slmm li#nav-menu-item-4662 > a{display:none;}
.slmm li#nav-menu-item-4633 > a{display:none;}
.slmm li#nav-menu-item-4620 > a{display:none;}
.slmm li#nav-menu-item-4661 > a{display:none;}
.slmm li#nav-menu-item-4621 > a{display:none;}
.slmm li#nav-menu-item-4636 > a{display:none;}
.slmm li#nav-menu-item-4622 > a{display:none;}
.slmm li#nav-menu-item-4655 > a{display:none;}
.slmm li#nav-menu-item-4623 > a{display:none;}
.slmm li#nav-menu-item-4641 > a{display:none;}
.slmm li#nav-menu-item-4634 > a{display:none;}
.slmm li#nav-menu-item-4654 > a{display:none;}
.slmm li#nav-menu-item-4625 > a{display:none;}
.slmm li#nav-menu-item-4646 > a{display:none;}
.slmm li#nav-menu-item-4645 > a{display:none;}
.slmm li#nav-menu-item-4644 > a{display:none;}
.slmm li#nav-menu-item-4643 > a{display:none;}
.slmm li#nav-menu-item-4642 > a{display:none;}
.slmm li#nav-menu-item-4631 > a{background-color:#f6f6f6;display:none;}
.slmm li#nav-menu-item-4632 > a{display:none;}
/*! CSS Used from: Embedded */
.page main{background-color:#ffffff;background-repeat:no-repeat;background-attachment:fixed;background-position:center center;background-size:inherit;}
main input[type="submit"]{padding-top:0px;padding-right:50px;padding-bottom:0px;padding-left:50px;}
main input[type="submit"]{border-top:2px solid #ED7D31;border-bottom:2px solid #ED7D31;border-left:2px solid #ED7D31;border-right:2px solid #ED7D31;}
input[type="text"],input[type="email"],input[type="search"],input[type="tel"],html body textarea{border-top:1px solid #e5e6eb;border-bottom:1px solid #e5e6eb;border-left:1px solid #e5e6eb;border-right:1px solid #e5e6eb;}
/*! CSS Used from: Embedded */
.kc-container{max-width:1170px;}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-794955{width:49%;}
body.kc-css-system .kc-css-511121{width:51%;}
body.kc-css-system .kc-css-6573516{width:25%;}
body.kc-css-system .kc-css-2855471{width:25%;}
body.kc-css-system .kc-css-1991276{width:25%;}
body.kc-css-system .kc-css-701254{width:25%;}
body.kc-css-system .kc-css-625011{width:100%;}
body.kc-css-system .kc-css-786902{width:33.33%;}
body.kc-css-system .kc-css-134987{width:33.33%;}
body.kc-css-system .kc-css-856904{width:33.33%;}
body.kc-css-system .kc-css-657917{width:100%;}
body.kc-css-system .kc-css-1668359{width:20%;}
body.kc-css-system .kc-css-2958724{width:20%;}
body.kc-css-system .kc-css-4346564{width:20%;}
body.kc-css-system .kc-css-4242384{width:20%;}
body.kc-css-system .kc-css-7898397{width:20%;}
body.kc-css-system .kc-css-204186{width:100%;}
body.kc-css-system .kc-css-914410{width:100%;}
body.kc-css-system .kc-css-6761113{width:33.33%;}
body.kc-css-system .kc-css-1256211{width:33.33%;}
body.kc-css-system .kc-css-6224324{width:33.33%;}
body.kc-css-system .kc-css-4950303{width:100%;}
body.kc-css-system .kc-css-6303361{width:100%;}
}
body.kc-css-system .kc-css-665494{padding-top:160px;padding-bottom:80px;}
body.kc-css-system .kc-css-511121{padding-top:60px;}
body.kc-css-system .kc-css-553400.ssc_mltttl .wr{text-align:left;}
body.kc-css-system .kc-css-553400{text-align:center;padding-bottom:5px;display:inline-block;}
body.kc-css-system .kc-css-553400 .deb:before{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-left:455px;}
body.kc-css-system .kc-css-553400 .deb:after{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-right:455px;}
body.kc-css-system .kc-css-553400 .t1{text-align:left;text-transform:full-size-kana;line-height:39px;display:inline;}
body.kc-css-system .kc-css-553400 .t2{color:#ED7D31;text-align:left;line-height:39px;display:inline;}
body.kc-css-system .kc-css-553400 .t3{text-align:left;line-height:39px;margin-top:5px;}
body.kc-css-system .kc-css-553400 .t4{font-size:22px;line-height:30px;padding-top:20px;display:block;}
body.kc-css-system .kc-css-194884{padding-top:5px;padding-right:3%;}
body.kc-css-system .kc-css-194884 p{margin-bottom:15px;}
body.kc-css-system .kc-css-5001346{text-align:center;padding-top:125px;padding-bottom:50px;}
body.kc-css-system .kc-css-5001346 .befbgr:nth-child(1) img{width:2002px;}
body.kc-css-system .kc-css-5001346 .befbgr:nth-child(1){text-align:center;padding-top:10px;}
body.kc-css-system .kc-css-3003281{text-align:center;}
body.kc-css-system .kc-css-3003281 .lbl{color:#222222;font-size:20px;line-height:28px;font-weight:600;padding-top:20px;}
body.kc-css-system .kc-css-3003281 .countbox{text-align:center;display:table;}
body.kc-css-system .kc-css-3003281 .num{color:#222222;font-size:64px;line-height:50px;font-weight:500;font-family:Montserrat;}
body.kc-css-system .kc-css-3003281 .suf{color:#ED7D31;font-size:55px;line-height:45px;font-weight:500;vertical-align:middle;}
body.kc-css-system .kc-css-3003281 .description{display:none!important;}
body.kc-css-system .kc-css-4867395{text-align:center;}
body.kc-css-system .kc-css-4867395 .lbl{color:#222222;font-size:20px;line-height:28px;font-weight:600;padding-top:20px;}
body.kc-css-system .kc-css-4867395 .countbox{text-align:center;display:table;}
body.kc-css-system .kc-css-4867395 .num{color:#222222;font-size:64px;line-height:50px;font-weight:500;font-family:Montserrat;}
body.kc-css-system .kc-css-4867395 .suf{color:#ED7D31;font-size:55px;line-height:45px;font-weight:500;vertical-align:middle;}
body.kc-css-system .kc-css-5643000{text-align:center;}
body.kc-css-system .kc-css-5643000 .lbl{color:#222222;font-size:20px;line-height:28px;font-weight:600;padding-top:20px;}
body.kc-css-system .kc-css-5643000 .countbox{text-align:center;display:table;}
body.kc-css-system .kc-css-5643000 .num{color:#222222;font-size:64px;line-height:50px;font-weight:500;font-family:Montserrat;}
body.kc-css-system .kc-css-5643000 .suf{color:#ED7D31;font-size:55px;line-height:45px;font-weight:500;vertical-align:middle;}
body.kc-css-system .kc-css-385440{text-align:center;}
body.kc-css-system .kc-css-385440 .lbl{color:#222222;font-size:20px;line-height:28px;font-weight:600;padding-top:20px;}
body.kc-css-system .kc-css-385440 .countbox{text-align:center;display:table;}
body.kc-css-system .kc-css-385440 .num{color:#222222;font-size:64px;line-height:50px;font-weight:500;font-family:Montserrat;}
body.kc-css-system .kc-css-385440 .suf{color:#ED7D31;font-size:55px;line-height:45px;font-weight:500;vertical-align:middle;}
body.kc-css-system .kc-css-41248{padding-top:45px;padding-bottom:160px;}
body.kc-css-system .kc-css-377211.ssc_mltttl .wr{text-align:center;}
body.kc-css-system .kc-css-377211{text-align:center;margin-bottom:0px;padding-top:25px;padding-bottom:25px;display:inline-block;}
body.kc-css-system .kc-css-377211 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;margin-top:10px;margin-right:-5px;}
body.kc-css-system .kc-css-377211 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:25px;margin-right:-10px;}
body.kc-css-system .kc-css-377211 .t1{line-height:45px;margin-bottom:0px;display:inline;}
body.kc-css-system .kc-css-377211 .t2{color:#ED7D31;line-height:45px;display:inline;}
body.kc-css-system .kc-css-377211 .t3{line-height:45px;display:inline;}
body.kc-css-system .kc-css-377211 .t4{margin-top:25px;padding-right:24.5%;padding-left:24.5%;}
body.kc-css-system .kc-css-756961{padding-top:20px;padding-bottom:70px;}
.kc-css-756961 >.kc_column_inner{padding-left:15px;padding-right:15px;}
body.kc-css-system .kc-css-418528{width:100%;padding:40px 45px 20px 45px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-418528 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-418528 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-418528 .title{color:#222222;font-size:20px;line-height:40px;font-weight:500;text-transform:none;padding-top:5px;}
body.kc-css-system .kc-css-418528 .cont_box .description{color:#666666;font-size:17px;margin-bottom:15px;}
body.kc-css-system .kc-css-418528 .cont_box .description,body.kc-css-system .kc-css-418528 .cont_box .description p{line-height:1.765em;}
body.kc-css-system .kc-css-418528 .icon_box{height:70px;}
body.kc-css-system .kc-css-418528 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-418528 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-418528:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-418528 .c_svg div{height:30px;}
body.kc-css-system .kc-css-418528:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-915899{width:100%;padding:40px 45px 20px 45px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-915899 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-915899 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-915899 .title{color:#222222;font-size:20px;line-height:40px;font-weight:500;text-transform:none;padding-top:5px;}
body.kc-css-system .kc-css-915899 .cont_box .description{color:#666666;font-size:17px;margin-bottom:15px;}
body.kc-css-system .kc-css-915899 .cont_box .description,body.kc-css-system .kc-css-915899 .cont_box .description p{line-height:1.765em;}
body.kc-css-system .kc-css-915899 .icon_box{height:70px;}
body.kc-css-system .kc-css-915899 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-915899 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-915899:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-915899 .c_svg div{height:30px;}
body.kc-css-system .kc-css-915899:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-69997{width:100%;padding:40px 45px 20px 45px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-69997 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-69997 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-69997 .title{color:#222222;font-size:20px;line-height:40px;font-weight:500;text-transform:none;padding-top:5px;}
body.kc-css-system .kc-css-69997 .cont_box .description{color:#666666;font-size:17px;margin-bottom:15px;}
body.kc-css-system .kc-css-69997 .cont_box .description,body.kc-css-system .kc-css-69997 .cont_box .description p{line-height:1.765em;}
body.kc-css-system .kc-css-69997 .icon_box{height:70px;}
body.kc-css-system .kc-css-69997 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-69997 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-69997:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-69997 .c_svg div{height:30px;}
body.kc-css-system .kc-css-69997:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-811640{z-index:2;}
body.kc-css-system .kc-css-8775 .divider_inner{border-color:#e4e7f2;border-style:solid;border-width:1px;}
body.kc-css-system .kc-css-8775{margin-top:28px;}
body.kc-css-system .kc-css-311746{background:#151823 url(../../assets/images/bak_form.png) center center/cover no-repeat scroll;padding-top:123px;padding-bottom:105px;}
body.kc-css-system .kc-css-5484550.ssc_mltttl .wr{text-align:center;}
body.kc-css-system .kc-css-5484550{text-align:center;display:inline-block;}
body.kc-css-system .kc-css-5484550 .deb:before{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-left:475px;}
body.kc-css-system .kc-css-5484550 .deb:after{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-right:475px;}
body.kc-css-system .kc-css-5484550 .t1{color:#ffffff;text-align:center;text-transform:none;line-height:39px;display:inline;}
body.kc-css-system .kc-css-5484550 .t2{color:#ED7D31;text-transform:full-size-kana;line-height:39px;display:inline;}
body.kc-css-system .kc-css-5484550 .t3{color:#ffffff;text-transform:none;line-height:39px;display:inline;}
body.kc-css-system .kc-css-5484550 .t4{color:#ffffff;text-align:center;text-transform:none;line-height:39px;margin-top:10px;}
body.kc-css-system .kc-css-5484550 .t5{color:#ffffff;padding-top:10px;padding-right:23%;padding-left:23%;}
body.kc-css-system .kc-css-5877124{text-align:center;float:none;max-width:580px;margin-right:auto;margin-left:auto;padding-top:45px;}
body.kc-css-system .kc-css-5877124 .caldera-grid .row > div{padding-right:15px;}
body.kc-css-system .kc-css-5877124 label{color:#949494;}
body.kc-css-system .kc-css-5877124 input{color:#ffffff;background:#151823;font-family:Catamaran;font-size:15px;line-height:29px;font-weight:400;text-align:left;width:100%;height:50px;border:1px solid #9296a4;border-radius:30px 30px 30px 30px;margin-bottom:15px;padding-top:0px;padding-bottom:0px;padding-left:30px;}
body.kc-css-system .kc-css-5877124 textarea{color:#ffffff;background:#151823;font-size:15px;line-height:35px;font-weight:400;border:1px solid #7e8399;border-radius:20px 20px 20px 20px;margin-top:10px;margin-bottom:25px;padding-top:5px;padding-left:30px;}
body.kc-css-system .kc-css-5877124 input::-webkit-input-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 input::-moz-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 input:-moz-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 input:-ms-input-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 textarea::-webkit-input-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 textarea::-moz-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 textarea:-moz-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 textarea:-ms-input-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 .caldera-grid input.btn{color:#ffffff;background:rgba(255, 255, 255, 0);height:45px;font-size:16px;line-height:27px;font-weight:500;text-align:left;text-transform:none;border:2px solid #ED7D31;border-radius:50px 50px 50px 50px;margin-left:0px;padding-right:60px;padding-bottom:0px;padding-left:60px;}
body.kc-css-system .kc-css-5877124 .caldera-grid input.btn:hover{color:#ffffff;background:#ED7D31;}
body.kc-css-system .kc-css-5877124 input:focus{box-shadow:none;border:1px solid #ED7D31;}
body.kc-css-system .kc-css-5877124 textarea:focus{box-shadow:none;border:1px solid #ED7D31;}
body.kc-css-system .kc-css-52198{background:transparent url(../../assets/images/steps-2.png) 50% 85%/auto no-repeat scroll;padding-top:120px;z-index:3;}
body.kc-css-system .kc-css-291136{text-align:center;display:inline-block;}
body.kc-css-system .kc-css-291136 .deb:before{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-left:455px;}
body.kc-css-system .kc-css-291136 .deb:after{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-right:455px;}
body.kc-css-system .kc-css-291136 .t1{text-align:center;text-transform:full-size-kana;display:inline;}
body.kc-css-system .kc-css-291136 .t2{color:#ED7D31;display:inline;}
body.kc-css-system .kc-css-291136 .t3{padding-top:17px;padding-right:24%;padding-left:24%;}
body.kc-css-system .kc-css-88592{background:transparent url(../../assets/images/Vector-1.png) center top/auto no-repeat scroll;margin-top:80px;margin-bottom:40px;}
body.kc-css-system .kc-css-1668359{padding-top:13px;}
body.kc-css-system .kc-css-3507557{text-align:center;width:100%;margin-top:-50px;margin-left:10px;padding-top:0px;padding-bottom:30px;}
body.kc-css-system .kc-css-3507557 .c_text{color:rgba(34, 34, 34, 0.30);}
body.kc-css-system .kc-css-3507557 .c_text{font-family:Montserrat;font-weight:500;}
body.kc-css-system .kc-css-3507557 .c_text{width:60px;height:30px;margin-top:-105px!important;padding-top:45px;}
body.kc-css-system .kc-css-3507557 .icon_box{background:#ffffff;display:inline-block;width:70px;height:70px;border:2px solid #ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-3507557 .bgr_icon{color:#222222;}
body.kc-css-system .kc-css-3507557 .bgr_icon i{font-size:35px;}
body.kc-css-system .kc-css-3507557 .bgr_icon i{line-height:33px;}
body.kc-css-system .kc-css-3507557 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-3507557 .bgr_icon i{height:70px!important;}
body.kc-css-system .kc-css-3507557 .bgr_icon{padding-top:17px;padding-bottom:15px;}
body.kc-css-system .kc-css-3507557 .title{color:#222222;font-size:20px;line-height:26px;font-weight:500;text-align:center;text-transform:full-size-kana;margin-top:25px;}
body.kc-css-system .kc-css-3507557 .cont_box .description{color:#666666;font-size:16px;font-weight:300;text-align:center;display:none;margin-bottom:15px;}
body.kc-css-system .kc-css-3507557 .cont_box .description{line-height:25px;}
body.kc-css-system .kc-css-3507557 .cont_box{text-align:center;}
body.kc-css-system .kc-css-3507557:hover .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-2958724{padding-top:100px;}
body.kc-css-system .kc-css-2958724{padding-top:121px;}
body.kc-css-system .kc-css-8738286{text-align:center;width:100%;margin-left:10px;padding-top:0px;padding-bottom:30px;}
body.kc-css-system .kc-css-8738286 .c_text{color:rgba(34, 34, 34, 0.30);}
body.kc-css-system .kc-css-8738286 .c_text{font-family:Montserrat;font-weight:500;}
body.kc-css-system .kc-css-8738286 .c_text{width:60px;height:30px;margin-top:-105px!important;padding-top:45px;}
body.kc-css-system .kc-css-8738286 .icon_box{background:#ffffff;display:inline-block;width:70px;height:70px;border:2px solid #ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-8738286 .bgr_icon{color:#222222;}
body.kc-css-system .kc-css-8738286 .bgr_icon i{font-size:35px;}
body.kc-css-system .kc-css-8738286 .bgr_icon i{line-height:33px;}
body.kc-css-system .kc-css-8738286 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-8738286 .bgr_icon i{height:70px!important;}
body.kc-css-system .kc-css-8738286 .bgr_icon{padding-top:17px;padding-bottom:15px;}
body.kc-css-system .kc-css-8738286 .title{color:#222222;font-size:20px;line-height:26px;font-weight:500;text-align:center;text-transform:full-size-kana;margin-top:25px;}
body.kc-css-system .kc-css-8738286 .cont_box .description{color:#666666;font-size:16px;font-weight:300;text-align:center;margin-bottom:15px;}
body.kc-css-system .kc-css-8738286 .cont_box .description{line-height:25px;}
body.kc-css-system .kc-css-8738286 .cont_box{text-align:center;}
body.kc-css-system .kc-css-8738286:hover .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-4346564{padding-top:19px;}
body.kc-css-system .kc-css-2273135{text-align:center;width:100%;margin-top:-15px;padding-top:0px;padding-bottom:30px;}
body.kc-css-system .kc-css-2273135 .c_text{color:rgba(34, 34, 34, 0.30);}
body.kc-css-system .kc-css-2273135 .c_text{font-family:Montserrat;font-weight:500;}
body.kc-css-system .kc-css-2273135 .c_text{width:60px;height:30px;margin-top:-105px!important;padding-top:45px;}
body.kc-css-system .kc-css-2273135 .icon_box{background:#ffffff;display:inline-block;width:70px;height:70px;border:2px solid #ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-2273135 .bgr_icon{color:#222222;}
body.kc-css-system .kc-css-2273135 .bgr_icon i{font-size:35px;}
body.kc-css-system .kc-css-2273135 .bgr_icon i{line-height:33px;}
body.kc-css-system .kc-css-2273135 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-2273135 .bgr_icon i{height:70px!important;}
body.kc-css-system .kc-css-2273135 .bgr_icon{padding-top:17px;padding-bottom:15px;}
body.kc-css-system .kc-css-2273135 .title{color:#222222;font-size:20px;line-height:26px;font-weight:500;text-align:center;text-transform:full-size-kana;margin-top:25px;}
body.kc-css-system .kc-css-2273135 .cont_box .description{color:#666666;font-size:16px;font-weight:300;text-align:center;margin-bottom:15px;}
body.kc-css-system .kc-css-2273135 .cont_box .description{line-height:25px;}
body.kc-css-system .kc-css-2273135 .cont_box{text-align:center;}
body.kc-css-system .kc-css-2273135:hover .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-4242384{padding-top:100px;}
body.kc-css-system .kc-css-4242384{padding-top:120px;}
body.kc-css-system .kc-css-9163363{text-align:center;width:100%;margin-top:-15px;padding-top:0px;padding-bottom:30px;}
body.kc-css-system .kc-css-9163363 .c_text{color:rgba(34, 34, 34, 0.30);}
body.kc-css-system .kc-css-9163363 .c_text{font-family:Montserrat;font-weight:500;}
body.kc-css-system .kc-css-9163363 .c_text{width:60px;height:30px;margin-top:-105px!important;padding-top:45px;}
body.kc-css-system .kc-css-9163363 .icon_box{background:#ffffff;display:inline-block;width:70px;height:70px;border:2px solid #ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-9163363 .bgr_icon{color:#222222;}
body.kc-css-system .kc-css-9163363 .bgr_icon i{font-size:35px;}
body.kc-css-system .kc-css-9163363 .bgr_icon i{line-height:33px;}
body.kc-css-system .kc-css-9163363 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-9163363 .bgr_icon i{height:70px!important;}
body.kc-css-system .kc-css-9163363 .bgr_icon{padding-top:17px;padding-bottom:15px;}
body.kc-css-system .kc-css-9163363 .title{color:#222222;font-size:20px;line-height:26px;font-weight:500;text-align:center;text-transform:full-size-kana;margin-top:25px;}
body.kc-css-system .kc-css-9163363 .cont_box .description{color:#666666;font-size:16px;font-weight:300;text-align:center;margin-bottom:15px;}
body.kc-css-system .kc-css-9163363 .cont_box .description{line-height:25px;}
body.kc-css-system .kc-css-9163363 .cont_box{text-align:center;}
body.kc-css-system .kc-css-9163363:hover .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-7898397{padding-top:69px;}
body.kc-css-system .kc-css-8440810{text-align:center;width:100%;margin-top:-15px;padding-top:0px;padding-bottom:30px;}
body.kc-css-system .kc-css-8440810 .c_text{color:rgba(34, 34, 34, 0.30);}
body.kc-css-system .kc-css-8440810 .c_text{font-family:Montserrat;font-weight:500;}
body.kc-css-system .kc-css-8440810 .c_text{width:60px;height:30px;margin-top:-105px!important;padding-top:45px;}
body.kc-css-system .kc-css-8440810 .icon_box{background:#ffffff;display:inline-block;width:70px;height:70px;border:2px solid #ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-8440810 .bgr_icon{color:#222222;}
body.kc-css-system .kc-css-8440810 .bgr_icon i{font-size:35px;}
body.kc-css-system .kc-css-8440810 .bgr_icon i{line-height:33px;}
body.kc-css-system .kc-css-8440810 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-8440810 .bgr_icon i{height:70px!important;}
body.kc-css-system .kc-css-8440810 .bgr_icon{padding-top:17px;padding-bottom:15px;}
body.kc-css-system .kc-css-8440810 .title{color:#222222;font-size:20px;line-height:26px;font-weight:500;text-align:center;text-transform:full-size-kana;margin-top:25px;}
body.kc-css-system .kc-css-8440810 .cont_box .description{color:#666666;font-size:16px;font-weight:300;text-align:center;margin-bottom:15px;}
body.kc-css-system .kc-css-8440810 .cont_box .description{line-height:25px;}
body.kc-css-system .kc-css-8440810 .cont_box{text-align:center;}
body.kc-css-system .kc-css-8440810:hover .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-753384{padding-top:15px;z-index:3;}
body.kc-css-system .kc-css-862000{text-align:center;display:inline-block;}
body.kc-css-system .kc-css-862000 .deb:before{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-left:455px;}
body.kc-css-system .kc-css-862000 .deb:after{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-right:455px;}
body.kc-css-system .kc-css-862000 .t1{text-align:center;text-transform:full-size-kana;display:inline;}
body.kc-css-system .kc-css-862000 .t2{color:#ED7D31;display:inline;}
body.kc-css-system .kc-css-862000 .t3{padding-top:17px;padding-right:21%;padding-left:21%;}
.kc-css-9949983 .kc_column{padding-left:0px;padding-right:0px;}
body.kc-css-system .kc-css-9949983{padding-top:45px;}
body.kc-css-system .kc-css-4350367 .owl-page span{background-color:rgba(243, 84, 68, 0.50);width:10px;height:5px;margin-right:5px;margin-left:5px;}
body.kc-css-system .kc-css-4350367 .owl-page.active span,body.kc-css-system .kc-css-4350367 .owl-page:hover span{background-color:#ED7D31;width:20px;height:5px;}
body.kc-css-system .kc-css-4350367 .owl-pagination{margin-top:40px;}
body.kc-css-system .kc-css-4350367 .owl-controls .owl-buttons div{color:#999999;background-color:rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-4350367 .owl-controls .owl-buttons div:hover{color:#ED7D31;background-color:rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-4350367 .owl-controls .owl-buttons{margin-top:-37px;}
body.kc-css-system .kc-css-4350367 .owl-controls .owl-buttons div svg{width:138px;height:18px;}
body.kc-css-system .kc-css-4350367 .svg{fill:#999999;fill:#999999;}
body.kc-css-system .kc-css-4350367 .svg:hover{fill:#ED7D31;fill:#ED7D31;}
body.kc-css-system .kc-css-2456229{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-7958940 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-7958940 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-7958940 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-7958940 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-7958940 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-7958940 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-7958940 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-7958940 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-7958940 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-1680313{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-6006576 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-6006576 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-6006576 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-6006576 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-6006576 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-6006576 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-6006576 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-6006576 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-6006576 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-7944104{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-8947119 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-8947119 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-8947119 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-8947119 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-8947119 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-8947119 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-8947119 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-8947119 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-8947119 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-6030634{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-2256400 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-2256400 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-2256400 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-2256400 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-2256400 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-2256400 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-2256400 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-2256400 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-2256400 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-952664{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-1101992 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-1101992 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-1101992 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-1101992 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-1101992 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-1101992 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-1101992 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-1101992 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-1101992 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-9858851{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-3138746 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-3138746 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-3138746 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-3138746 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-3138746 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-3138746 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-3138746 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-3138746 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-3138746 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-6494345{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-6018402 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-6018402 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-6018402 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-6018402 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-6018402 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-6018402 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-6018402 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-6018402 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-6018402 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-357535{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-778068 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-778068 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-778068 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-778068 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-778068 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-778068 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-778068 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-778068 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-778068 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-681494{padding-top:85px;padding-bottom:120px;}
body.kc-css-system .kc-css-7840720{text-align:center;display:inline-block;}
body.kc-css-system .kc-css-7840720 .deb:before{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-left:455px;}
body.kc-css-system .kc-css-7840720 .deb:after{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-right:455px;}
body.kc-css-system .kc-css-7840720 .t1{text-align:center;text-transform:full-size-kana;display:inline;}
body.kc-css-system .kc-css-7840720 .t2{color:#ED7D31;display:inline;}
body.kc-css-system .kc-css-7840720 .t3{padding-top:17px;padding-right:24%;padding-left:24%;}
body.kc-css-system .kc-css-8811014{padding-top:55px;}
body.kc-css-system .kc-css-1686081 .content-title{color:#222222;font-family:Montserrat;font-size:25px;font-weight:500;line-height:25px;text-transform:none;text-align:left;background-color:rgba(246, 247, 251, 0);padding-bottom:25px;padding-left:60px;}
body.kc-css-system .kc-css-1686081 .content-price{color:#222222;font-size:52px;font-weight:500;line-height:58px;padding-top:10px;padding-bottom:25px;padding-left:60px;}
body.kc-css-system .kc-css-1686081 .kc-pricing-price{font-family:Montserrat;text-align:left;background-color:rgba(246, 247, 251, 0);}
body.kc-css-system .kc-css-1686081 .kc-pricing-price span.content-duration{color:#222222;font-family:Montserrat;font-size:25px;font-weight:600;padding-left:5px;}
body.kc-css-system .kc-css-1686081 .content-desc li{color:#666666;font-family:Catamaran;font-size:17px;font-weight:400;line-height:24px;text-align:left;}
body.kc-css-system .kc-css-1686081 .content-desc{background-color:rgba(246, 247, 251, 0);padding-top:15px;padding-right:0px;padding-left:60px;}
body.kc-css-system .kc-css-1686081 .content-desc li:nth-of-type(2n+1){background-color:rgba(246, 247, 251, 0);}
body.kc-css-system .kc-css-1686081 .content-button a{color:#222222;background:#f6f7fb;font-size:16px;line-height:20px;font-weight:500;text-transform:none;border:2px solid #ED7D31;border-radius:50px 50px 50px 50px;padding:12px 50px 12px 50px;margin-top:63px;margin-bottom:15px;}
body.kc-css-system .kc-css-1686081 .content-button a:hover{color:#ffffff;background-color:#ED7D31;}
body.kc-css-system .kc-css-1686081 .content-button{background-color:rgba(246, 247, 251, 0);text-align:center;}
body.kc-css-system .kc-css-1686081{background:#f6f7fb url(../../assets/images/land_price.png) top right/auto no-repeat scroll;max-width:360px;border:1px solid rgba(228, 231, 242, 0);padding-top:60px;padding-bottom:60px;}
body.kc-css-system .kc-css-1686081.kc-pricing-tables{box-shadow:none;}
body.kc-css-system .kc-css-8007722 .content-title{color:#ffffff;font-family:Montserrat;font-size:25px;font-weight:500;line-height:25px;text-transform:none;text-align:left;background-color:rgba(246, 247, 251, 0);padding-bottom:25px;padding-left:60px;}
body.kc-css-system .kc-css-8007722 .content-price{color:#ffffff;font-size:52px;font-weight:500;line-height:58px;padding-top:10px;padding-bottom:25px;padding-left:60px;}
body.kc-css-system .kc-css-8007722 .kc-pricing-price{font-family:Montserrat;text-align:left;background-color:rgba(246, 247, 251, 0);}
body.kc-css-system .kc-css-8007722 .kc-pricing-price span.content-duration{color:#ffffff;font-family:Montserrat;font-size:25px;font-weight:600;padding-left:5px;}
body.kc-css-system .kc-css-8007722 .content-desc li{color:#ffffff;font-family:Catamaran;font-size:17px;font-weight:400;line-height:24px;text-align:left;}
body.kc-css-system .kc-css-8007722 .content-desc{background-color:rgba(246, 247, 251, 0);padding-top:15px;padding-right:0px;padding-left:60px;}
body.kc-css-system .kc-css-8007722 .content-desc li:nth-of-type(2n+1){background-color:rgba(246, 247, 251, 0);}
body.kc-css-system .kc-css-8007722 .content-button a{color:#ffffff;background:#31333e;font-size:16px;line-height:20px;font-weight:500;text-transform:none;border:2px solid #ED7D31;border-radius:50px 50px 50px 50px;padding:12px 50px 12px 50px;margin-top:63px;margin-bottom:15px;}
body.kc-css-system .kc-css-8007722 .content-button a:hover{color:#ffffff;background-color:#ED7D31;}
body.kc-css-system .kc-css-8007722 .content-button{background-color:rgba(246, 247, 251, 0);text-align:center;}
body.kc-css-system .kc-css-8007722{background:#31333e url(../../assets/images/app_price.png) top right/auto no-repeat scroll;max-width:360px;border:1px solid rgba(228, 231, 242, 0);padding-top:60px;padding-bottom:60px;}
body.kc-css-system .kc-css-8007722.kc-pricing-tables{box-shadow:none;}
body.kc-css-system .kc-css-5135966 .content-title{color:#222222;font-family:Montserrat;font-size:25px;font-weight:500;line-height:25px;text-transform:none;text-align:left;background-color:rgba(246, 247, 251, 0);padding-bottom:25px;padding-left:60px;}
body.kc-css-system .kc-css-5135966 .content-price{color:#222222;font-size:52px;font-weight:500;line-height:58px;padding-top:10px;padding-bottom:25px;padding-left:60px;}
body.kc-css-system .kc-css-5135966 .kc-pricing-price{font-family:Montserrat;text-align:left;background-color:rgba(246, 247, 251, 0);}
body.kc-css-system .kc-css-5135966 .kc-pricing-price span.content-duration{color:#222222;font-family:Montserrat;font-size:25px;font-weight:600;padding-left:5px;}
body.kc-css-system .kc-css-5135966 .content-desc li{color:#666666;font-family:Catamaran;font-size:17px;font-weight:400;line-height:24px;text-align:left;}
body.kc-css-system .kc-css-5135966 .content-desc{background-color:rgba(246, 247, 251, 0);padding-top:15px;padding-right:0px;padding-left:60px;}
body.kc-css-system .kc-css-5135966 .content-desc li:nth-of-type(2n+1){background-color:rgba(246, 247, 251, 0);}
body.kc-css-system .kc-css-5135966 .content-button a{color:#222222;background:#f6f7fb;font-size:16px;line-height:20px;font-weight:500;text-transform:none;border:2px solid #ED7D31;border-radius:50px 50px 50px 50px;padding:12px 50px 12px 50px;margin-top:63px;margin-bottom:15px;}
body.kc-css-system .kc-css-5135966 .content-button a:hover{color:#ffffff;background-color:#ED7D31;}
body.kc-css-system .kc-css-5135966 .content-button{background-color:rgba(246, 247, 251, 0);text-align:center;}
body.kc-css-system .kc-css-5135966{background:#f6f7fb url(../../assets/images/ecom_price.png) top right/auto no-repeat scroll;border:1px solid rgba(228, 231, 242, 0);padding-top:60px;padding-bottom:60px;}
body.kc-css-system .kc-css-5135966.kc-pricing-tables{box-shadow:none;}
body.kc-css-system .kc-css-2914915{background:#31333e url(../../assets/images/For-BG-02-1.jpg) top left/cover no-repeat fixed;padding-top:122px;padding-bottom:117px;}
body.kc-css-system .kc-css-7059139.ssc_mltttl .wr{color:#ffffff;text-align:center;}
body.kc-css-system .kc-css-7059139{text-align:center;display:inline-block;}
body.kc-css-system .kc-css-7059139 .deb:before{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-left:455px;}
body.kc-css-system .kc-css-7059139 .deb:after{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-right:455px;}
body.kc-css-system .kc-css-7059139 .t1{color:#ffffff;text-align:left;text-transform:full-size-kana;display:inline;}
body.kc-css-system .kc-css-7059139 .t2{color:#ED7D31;text-align:left;text-transform:none;display:inline;}
body.kc-css-system .kc-css-7059139 .t3{color:#ffffff;text-align:left;display:inline;}
body.kc-css-system .kc-css-7059139 .t4{text-align:center;padding-top:17px;display:block;}
body.kc-css-system .kc-css-5967827{text-align:center;float:none;max-width:840px;margin-left:21%;padding-top:65px;}
body.kc-css-system .kc-css-5967827 .caldera-grid .row{text-align:left;margin-right:0px;margin-left:0px;}
body.kc-css-system .kc-css-5967827 .caldera-grid .row > div{text-align:left;padding-right:0px;padding-left:0px;}
body.kc-css-system .kc-css-5967827 label{color:#949494;}
body.kc-css-system .kc-css-5967827 input{color:#ffffff;background:rgba(116, 131, 190, 0);font-size:15px;line-height:29px;font-weight:400;text-align:left;width:470px;height:50px;border:1px solid #7e8399;border-radius:30px 30px 30px 30px;margin-bottom:15px;padding-left:30px;}
body.kc-css-system .kc-css-5967827 input::-webkit-input-placeholder{color:#666666;color:#ffffff;}
body.kc-css-system .kc-css-5967827 input::-moz-placeholder{color:#666666;color:#ffffff;}
body.kc-css-system .kc-css-5967827 input:-moz-placeholder{color:#666666;}
body.kc-css-system .kc-css-5967827 input:-ms-input-placeholder{color:#666666;color:#ffffff;}
body.kc-css-system .kc-css-5967827 .caldera-grid input.btn{color:#ffffff;background:rgba(255, 255, 255, 0);font-size:16px;line-height:22px;font-weight:500;text-align:center;text-transform:none;border:2px solid #ED7D31;border-radius:50px 50px 50px 50px;padding:12px 55px 12px 55px;}
body.kc-css-system .kc-css-5967827 .caldera-grid input.btn:hover{color:#ffffff;background:#ED7D31;}
body.kc-css-system .kc-css-5967827 input:focus{box-shadow:none;border:1px solid #ED7D31;}
body.kc-css-system .kc-css-9340885{padding-top:120px;padding-bottom:80px;}
body.kc-css-system .kc-css-2350231{text-align:center;display:inline-block;}
body.kc-css-system .kc-css-2350231 .deb:before{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-left:455px;}
body.kc-css-system .kc-css-2350231 .deb:after{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-right:455px;}
body.kc-css-system .kc-css-2350231 .t1{text-align:center;text-transform:full-size-kana;display:inline;}
body.kc-css-system .kc-css-2350231 .t2{color:#ED7D31;display:inline;}
body.kc-css-system .kc-css-2350231 .t3{padding-top:22px;padding-right:25%;padding-left:25%;}
body.kc-css-system .kc-css-6303361{padding-right:0px;padding-left:0px;}
body.kc-css-system .kc-css-5304899{padding-top:55px;padding-right:0px;padding-left:0px;}
body.kc-css-system .kc-css-5304899 .grid-item{margin-bottom:30px;padding-top:0px;padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-5304899 .grid-item .pbody{background:#ffffff;padding-bottom:15px;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-5304899 .grid-item .body{padding-top:30px;padding-right:40px;padding-bottom:5px;}
body.kc-css-system .kc-css-5304899 .grid-item .title a{color:#222222;font-size:25px;line-height:32px;font-weight:500;font-family:Catamaran;padding-bottom:15px;}
body.kc-css-system .kc-css-5304899 .grid-item .meta{color:#666666;font-size:14px;line-height:20px;display:inline-block;}
body.kc-css-system .kc-css-5304899 .grid-item .meta a{color:#666666;text-decoration:none;margin-bottom:0px;}
body.kc-css-system .kc-css-5304899 .grid-item .meta i{color:#ffffff;display:none;}
body.kc-css-system .kc-css-5304899 .grid-item .date{font-weight:400;text-align:left;padding-bottom:12px;}
body.kc-css-system .kc-css-5304899 .grid-item p{color:#666666;font-size:17px;line-height:1.5em;font-weight:400;font-family:Catamaran;margin-top:-10px;padding-bottom:15px;}
body.kc-css-system .kc-css-5304899 .grid-item a.rm{color:#666666;font-size:14px;line-height:16px;font-weight:500;font-family:Catamaran;text-align:left;text-transform:uppercase;text-decoration:none;}
body.kc-css-system .kc-css-5304899 .grid-item .title a:hover{color:#ED7D31;}
body.kc-css-system .kc-css-5304899 .grid-item:hover .title a{color:#ED7D31;}
body.kc-css-system .kc-css-5304899 .grid-item .meta a:hover{color:#ED7D31;}
body.kc-css-system .kc-css-5304899 .grid-item a.rm:hover{color:#ED7D31;}
@media only screen and (max-width:768px){
body.kc-css-system .kc-css-553400 .deb:before{display:none;}
body.kc-css-system .kc-css-553400 .deb:after{display:none;}
body.kc-css-system .kc-css-5484550 .deb:before{display:none;}
body.kc-css-system .kc-css-5484550 .deb:after{display:none;}
body.kc-css-system .kc-css-5877124 input{margin-top:10px!important;margin-bottom:10px!important;}
body.kc-css-system .kc-css-291136 .deb:before{display:none;}
body.kc-css-system .kc-css-291136 .deb:after{display:none;}
body.kc-css-system .kc-css-3507557{text-align:left;margin-top:0px;margin-left:15px;}
body.kc-css-system .kc-css-3507557 .c_text{margin-top:-32px!important;margin-left:-70px!important;}
body.kc-css-system .kc-css-3507557 .icon_box{margin-top:0px;margin-left:20px;}
body.kc-css-system .kc-css-3507557 .cont_box .description{font-size:16px;}
body.kc-css-system .kc-css-3507557 .cont_box .description{line-height:25px;}
body.kc-css-system .kc-css-3507557 .cont_box{display:inline-block;}
body.kc-css-system .kc-css-8738286{text-align:left;margin-top:0px;margin-left:15px;}
body.kc-css-system .kc-css-8738286 .c_text{margin-top:-32px!important;margin-left:-70px!important;}
body.kc-css-system .kc-css-8738286 .icon_box{margin-top:0px;margin-right:20px;margin-left:20px;}
body.kc-css-system .kc-css-8738286 .cont_box .description{font-size:16px;}
body.kc-css-system .kc-css-8738286 .cont_box .description{line-height:25px;}
body.kc-css-system .kc-css-8738286 .cont_box{display:inline-block;}
body.kc-css-system .kc-css-2273135{text-align:left;margin-top:0px;margin-left:15px;}
body.kc-css-system .kc-css-2273135 .c_text{margin-top:-32px!important;margin-left:-70px!important;}
body.kc-css-system .kc-css-2273135 .icon_box{margin-top:0px;margin-right:20px;margin-left:20px;}
body.kc-css-system .kc-css-2273135 .cont_box .description{font-size:16px;}
body.kc-css-system .kc-css-2273135 .cont_box .description{line-height:25px;}
body.kc-css-system .kc-css-2273135 .cont_box{display:inline-block;}
body.kc-css-system .kc-css-9163363{text-align:left;margin-top:0px;margin-left:15px;}
body.kc-css-system .kc-css-9163363 .c_text{margin-top:-32px!important;margin-left:-70px!important;}
body.kc-css-system .kc-css-9163363 .icon_box{margin-top:0px;margin-right:20px;margin-left:20px;}
body.kc-css-system .kc-css-9163363 .cont_box .description{font-size:16px;}
body.kc-css-system .kc-css-9163363 .cont_box .description{line-height:25px;}
body.kc-css-system .kc-css-9163363 .cont_box{display:inline-block;}
body.kc-css-system .kc-css-8440810{text-align:left;margin-top:0px;margin-left:15px;}
body.kc-css-system .kc-css-8440810 .c_text{margin-top:-32px!important;margin-left:-70px!important;}
body.kc-css-system .kc-css-8440810 .icon_box{margin-top:0px;margin-left:20px;}
body.kc-css-system .kc-css-8440810 .cont_box .description{font-size:16px;}
body.kc-css-system .kc-css-8440810 .cont_box .description{line-height:25px;}
body.kc-css-system .kc-css-8440810 .cont_box{display:inline-block;}
body.kc-css-system .kc-css-862000 .deb:before{display:none;}
body.kc-css-system .kc-css-862000 .deb:after{display:none;}
body.kc-css-system .kc-css-7840720 .deb:before{display:none;}
body.kc-css-system .kc-css-7840720 .deb:after{display:none;}
body.kc-css-system .kc-css-7059139 .deb:before{display:none;}
body.kc-css-system .kc-css-7059139 .deb:after{display:none;}
body.kc-css-system .kc-css-2350231 .deb:before{display:none;}
body.kc-css-system .kc-css-2350231 .deb:after{display:none;}
}
@media only screen and (max-width:667px){
body.kc-css-system .kc-css-377211 .t4{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-291136 .t3{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-3507557{display:flex;width:100%;margin-left:0px;padding-bottom:30px;padding-left:15%;}
body.kc-css-system .kc-css-3507557 .title{padding-left:10px;}
body.kc-css-system .kc-css-8738286{display:flex;width:100%;margin-left:0px;padding-bottom:30px;padding-left:15%;}
body.kc-css-system .kc-css-8738286 .title{padding-left:10px;}
body.kc-css-system .kc-css-2273135{display:flex;width:100%;margin-left:0px;padding-bottom:30px;padding-left:15%;}
body.kc-css-system .kc-css-2273135 .title{padding-left:10px;}
body.kc-css-system .kc-css-9163363{display:flex;width:100%;margin-left:0px;padding-bottom:30px;padding-left:15%;}
body.kc-css-system .kc-css-9163363 .title{padding-left:10px;}
body.kc-css-system .kc-css-8440810{display:flex;width:100%;margin-left:0px;padding-bottom:30px;padding-left:15%;}
body.kc-css-system .kc-css-8440810 .title{padding-left:10px;}
}
@media only screen and (max-width:1024px){
body.kc-css-system .kc-css-3003281{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-4867395{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-5643000{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-385440{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-422242{display:none;}
body.kc-css-system .kc-css-469547{display:none;}
body.kc-css-system .kc-css-657917 .kc-col-container{width:100%;}
body.kc-css-system .kc-css-204186 .kc-col-container{width:100%;}
body.kc-css-system .kc-css-1686081 .content-desc{padding-left:30px;}
body.kc-css-system .kc-css-1686081{margin-bottom:20px;}
body.kc-css-system .kc-css-8007722 .content-desc{padding-left:30px;}
body.kc-css-system .kc-css-8007722{margin-bottom:20px;}
body.kc-css-system .kc-css-5135966 .content-desc{padding-left:30px;}
body.kc-css-system .kc-css-5135966{margin-bottom:20px;}
}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-794955{padding-right:0px;}
body.kc-css-system .kc-css-511121{padding-right:0px;}
body.kc-css-system .kc-css-511121{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-366355{display:none;}
body.kc-css-system .kc-css-595041{display:none;}
body.kc-css-system .kc-css-6573516{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-3003281{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-2855471{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-4867395{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-1991276{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-5643000{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-701254{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-385440{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-625011{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-786902{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-418528{width:100%;}
body.kc-css-system .kc-css-134987{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-915899{width:100%;}
body.kc-css-system .kc-css-856904{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-69997{width:100%;}
body.kc-css-system .kc-css-811640{display:none;}
body.kc-css-system .kc-css-5484550 .deb:before{padding-left:345px;}
body.kc-css-system .kc-css-5484550 .deb:after{padding-right:345px;}
body.kc-css-system .kc-css-52198{background:transparent url(../../assets/images/office-3.jpg) -750px bottom/auto no-repeat scroll;}
body.kc-css-system .kc-css-657917 .kc-col-container{padding-right:15px;}
body.kc-css-system .kc-css-657917{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-753384{background:transparent url(../../assets/images/office-3.jpg) -750px bottom/auto no-repeat scroll;padding-top:15px;}
body.kc-css-system .kc-css-204186 .kc-col-container{padding-right:15px;}
body.kc-css-system .kc-css-204186{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-914410{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-6761113{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-1686081 .content-title{text-align:center;}
body.kc-css-system .kc-css-1686081 .kc-pricing-price{display:block;}
body.kc-css-system .kc-css-1686081 .content-desc li{text-align:left;}
body.kc-css-system .kc-css-1686081 .content-button{text-align:center;}
body.kc-css-system .kc-css-1686081{float:none;margin-right:auto;margin-left:auto;}
body.kc-css-system .kc-css-1256211{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-8007722 .content-title{text-align:center;}
body.kc-css-system .kc-css-8007722 .kc-pricing-price{display:block;}
body.kc-css-system .kc-css-8007722 .content-desc li{text-align:left;}
body.kc-css-system .kc-css-8007722 .content-button{text-align:center;}
body.kc-css-system .kc-css-8007722{float:none;margin-right:auto;margin-left:auto;}
body.kc-css-system .kc-css-6224324{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-5135966 .content-title{text-align:center;}
body.kc-css-system .kc-css-5135966 .kc-pricing-price{display:block;}
body.kc-css-system .kc-css-5135966 .content-desc li{text-align:left;}
body.kc-css-system .kc-css-5135966 .content-button{text-align:center;}
body.kc-css-system .kc-css-5135966{float:none;max-width:360px;margin-right:auto;margin-left:auto;}
body.kc-css-system .kc-css-4950303{padding-left:15px;}
body.kc-css-system .kc-css-5967827{text-align:center;float:none;width:100%;margin-right:auto;margin-left:auto;}
body.kc-css-system .kc-css-5967827 input{width:400px;}
body.kc-css-system .kc-css-5967827 .caldera-grid input.btn{margin-left:0px;}
}
@media only screen and (max-width:767px){
body.kc-css-system .kc-css-5001346{padding-top:80px;}
body.kc-css-system .kc-css-3003281{padding-top:30px;padding-right:20px;padding-bottom:30px;border:1px solid rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-4867395{padding-top:30px;padding-right:20px;padding-bottom:30px;border:1px solid rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-5643000{padding-top:30px;padding-right:20px;padding-bottom:30px;border:1px solid rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-385440{padding-top:30px;padding-right:20px;padding-bottom:30px;border:1px solid rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-88592{background:#ffffff;padding-left:26px;}
body.kc-css-system .kc-css-2958724{padding-top:0px;}
body.kc-css-system .kc-css-2958724{padding-top:0px;}
body.kc-css-system .kc-css-4346564{padding-top:0px;}
body.kc-css-system .kc-css-4242384{padding-top:15px;}
body.kc-css-system .kc-css-4242384{padding-top:0px;}
body.kc-css-system .kc-css-7898397{padding-top:0px;}
body.kc-css-system .kc-css-7898397{padding-top:0px;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-665494{padding-top:80px;padding-bottom:0px;}
body.kc-css-system .kc-css-553400{padding-right:15px;}
body.kc-css-system .kc-css-553400 .t3{margin-top:0px;}
body.kc-css-system .kc-css-553400 .t4{padding-right:0px;}
body.kc-css-system .kc-css-194884{padding-right:15px;}
body.kc-css-system .kc-css-3003281 .num{font-size:40px;line-height:50px;}
body.kc-css-system .kc-css-4867395 .num{font-size:40px;line-height:50px;}
body.kc-css-system .kc-css-5643000 .num{font-size:40px;line-height:50px;}
body.kc-css-system .kc-css-385440 .num{font-size:40px;line-height:50px;}
body.kc-css-system .kc-css-41248{padding-top:30px;padding-bottom:40px;}
body.kc-css-system .kc-css-756961{padding-bottom:40px;}
body.kc-css-system .kc-css-311746{padding-top:80px;padding-bottom:80px;}
body.kc-css-system .kc-css-5484550 .t4{margin-top:0px;}
body.kc-css-system .kc-css-5484550 .t5{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-5877124 textarea{margin-top:0px;}
body.kc-css-system .kc-css-52198{padding-top:80px;}
body.kc-css-system .kc-css-1668359{text-align:center;padding-top:15px;}
body.kc-css-system .kc-css-3507557{text-align:center;display:flex;width:100%;padding-bottom:30px;}
body.kc-css-system .kc-css-3507557 .title{font-size:16px;padding-left:25px;}
body.kc-css-system .kc-css-3507557 .cont_box{text-align:center;}
body.kc-css-system .kc-css-2958724{padding-top:0px;}
body.kc-css-system .kc-css-8738286{text-align:center;display:flex;width:100%;padding-bottom:30px;}
body.kc-css-system .kc-css-8738286 .title{font-size:16px;padding-left:10px;}
body.kc-css-system .kc-css-8738286 .cont_box{text-align:center;}
body.kc-css-system .kc-css-4346564{padding-top:15px;}
body.kc-css-system .kc-css-2273135{text-align:center;display:flex;width:100%;padding-bottom:30px;}
body.kc-css-system .kc-css-2273135 .title{font-size:16px;padding-left:10px;}
body.kc-css-system .kc-css-2273135 .cont_box{text-align:center;}
body.kc-css-system .kc-css-4242384{padding-top:15px;}
body.kc-css-system .kc-css-9163363{text-align:center;display:flex;width:100%;padding-bottom:30px;}
body.kc-css-system .kc-css-9163363 .title{font-size:16px;padding-left:10px;}
body.kc-css-system .kc-css-9163363 .cont_box{text-align:center;}
body.kc-css-system .kc-css-7898397{padding-top:15px;}
body.kc-css-system .kc-css-8440810{text-align:center;display:flex;width:100%;padding-bottom:30px;}
body.kc-css-system .kc-css-8440810 .title{font-size:16px;margin-right:-5px;padding-left:10px;}
body.kc-css-system .kc-css-8440810 .cont_box{text-align:center;}
body.kc-css-system .kc-css-862000 .t3{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-914410{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-4350367 .owl-controls .owl-buttons{margin-top:0px;}
body.kc-css-system .kc-css-681494{padding-top:40px;padding-bottom:80px;}
body.kc-css-system .kc-css-7840720 .t3{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-8007722{float:none;margin-right:auto;margin-left:auto;}
body.kc-css-system .kc-css-2914915{padding-top:80px;padding-bottom:80px;}
body.kc-css-system .kc-css-3608988{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-5967827 input{width:100%!important;margin-left:0px;}
body.kc-css-system .kc-css-9340885{padding-top:80px;padding-bottom:80px;}
body.kc-css-system .kc-css-2350231 .t3{font-size:20px;line-height:26px;padding-top:30px;padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-5304899 .grid-item .title a{font-size:22px;}
}
/*! CSS Used from: Embedded */
#rev_slider_33_1_wrapper{height:800px;}
/*! CSS Used keyframes */
@keyframes tp-bouncedelay{0%,80%,100%{transform:scale(0);}40%{transform:scale(1);}}
/*! CSS Used fontfaces */
@font-face{font-display:swap;font-family:'native';src:url(../../assets/fonts/native.eot?3hn4ip);src:url('../../assets/fonts/native.eot?3hn4ip#iefix') format('embedded-opentype'),url(../../assets/fonts/native.ttf?3hn4ip) format('truetype'),url(../../assets/fonts/native.woff?3hn4ip) format('woff'),url('../../assets/fonts/native.svg?3hn4ip#native') format('svg');font-weight:400;font-style:normal;}
@font-face{font-display:swap;font-family:'simple-line-icons';src:url(../../assets/fonts/Simple-Line-Icons.eot?-i3a2kk);src:url('../../assets/fonts/Simple-Line-Icons.eot#iefix-i3a2kk') format('embedded-opentype'),url(../../assets/fonts/Simple-Line-Icons.ttf) format('truetype'),url(../../assets/fonts/Simple-Line-Icons.woff) format('woff'),url('../../assets/fonts/Simple-Line-Icons.svg#simple-line-icons') format('svg');font-weight:400;font-style:normal;}
@font-face{font-display:swap;font-family:'FontAwesome';src:url(../../assets/fonts/fa-solid-900.eot);src:url("../../assets/fonts/fa-solid-900.eot#iefix") format("embedded-opentype"),url(../../assets/fonts/fa-solid-900.woff2) format("woff2"),url(../../assets/fonts/fa-solid-900.woff) format("woff"),url(../../assets/fonts/fa-solid-900.ttf) format("truetype"),url("../../assets/fonts/fa-solid-900.svg#fontawesome") format("svg");font-weight:400;font-style:normal;}
@font-face{font-display:swap;font-family:'FontAwesomeBrands';font-style:normal;font-weight:400;src:url(../../assets/fonts/fa-brands-400.eot);src:url("../../assets/fonts/fa-brands-400.eot#iefix") format("embedded-opentype"),url(../../assets/fonts/fa-brands-400.woff2) format("woff2"),url(../../assets/fonts/fa-brands-400.woff) format("woff"),url(../../assets/fonts/fa-brands-400.ttf) format("truetype"),url("../../assets/fonts/fa-brands-400.svg#fontawesome") format("svg");}
</style>


// WEBPACK FOOTER //
// src/components/Blocks/Banner.vue